import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { KivonatSzuro, uresKivonatSzuro, kivonatQuery, kivonatCimkek } from '../kivonat-szukites/kivonat-szukites.component';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AlertController, IonModal, ToastController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { NaploService } from '../naplo.service';
import { szamlakepAblakba } from '../szamlakep-ablak';
import { stornoE, stornoParKeres, eredetiKeres } from '../storno-par';
import { DataService } from '../../data.service';
import { torzsadatMezok, torzsadatTablak, TorzsMezo, TorzsTabla, torzsForrasNev } from '../nav-torzsadat-mezok';
import { SzerkZar, SzerkZarService } from '../../components/szerk-zar/szerk-zar.service';

// KETTOS – kettős könyvelés nézet a NAPLO-n belül. A „Könyvelés" menü ide irányít, ha az
// aktív ügyfél konyveles_mod='kettos'. Szegmensek: Kontírozás (naplók) / Főkönyvi kivonat /
// Számlatükör / Beállítások. A kontírozó a naplótól függő ellenszámlát automatikusan beírja,
// a költség-/bevétel-számlát pedig a korábbi tételekből tanult szabály alapján felajánlja.
/** A végszámla saját bizonylatában álló előleg-beszámítás (2. tétel) sorainak megjegyzése – ebből ismerjük fel. */
const BESZAMITAS_JEL = 'Előleg beszámítása';

@Component({
  selector: 'app-naplo-kettos',
  templateUrl: './kettos.component.html',
  styleUrls: ['../naplo-shared.scss', './kettos.component.scss'],
})
export class KettosComponent implements OnInit, OnDestroy {
  @ViewChild('urlap') urlap?: ElementRef<HTMLElement>;
  @ViewChild('szlaModal') szlaModal: IonModal;
  @ViewChild('partnerModal') partnerModal: IonModal;
  @ViewChild('partnerPicker') partnerPicker: IonModal;
  @ViewChild('szlaValaszto') szlaValaszto: IonModal;
  @ViewChild('osaModal') osaModal?: IonModal;

  private readonly base = '/api/kettos';
  nezet: 'kontir' | 'osa' | 'kivonat' | 'eredmeny' | 'merleg' | 'afa' | 'partner' | 'tukor' | 'navtorzs' | 'zaras' | 'beallitas' = 'kontir';
  /*  A nézetet a NAPLO FŐMENÜJE választja ki (`?nezet=…`, naplo-menu.ts) – egyszeres és kettős
   *  könyvelés ugyanazt a menüt használja. A régi kétszintű belső navigáció ezért kikerült. */
  static readonly CIMEK: Record<string, { cim: string; fomenu: string }> = {
    kontir: { cim: 'Könyvelés', fomenu: 'Könyvelés' },
    osa: { cim: 'Online Számla (OSA)', fomenu: 'Könyvelés' },
    zaras: { cim: 'Nyitás / zárás', fomenu: 'Könyvelés' },
    kivonat: { cim: 'Főkönyvi kivonat', fomenu: 'Naplók' },
    eredmeny: { cim: 'Eredménykimutatás', fomenu: 'Naplók' },
    merleg: { cim: 'Mérleg', fomenu: 'Naplók' },
    afa: { cim: 'ÁFA-analitika', fomenu: 'Naplók' },
    partner: { cim: 'Partnertörzs', fomenu: 'Törzsadatok' },
    tukor: { cim: 'Főkönyvi számlatükör', fomenu: 'Törzsadatok' },
    navtorzs: { cim: 'NAV törzsadat', fomenu: 'Törzsadatok' },
    beallitas: { cim: 'Könyvelési beállítások', fomenu: 'Törzsadatok' },
  };
  get nezetCim() {
    if (this.nezet === 'kontir') return this.naploCim(this.aktivNaplo);
    return KettosComponent.CIMEK[this.nezet]?.cim || 'Kettős könyvelés';
  }
  naploCim(n: string) {
    return ({ vevo: 'Vevő számla könyvelése', szallito: 'Szállító számla könyvelése', penztar: 'Pénztár könyvelése',
              bank: 'Bank könyvelése', vegyes: 'Vegyes könyvelés' } as any)[n] || 'Könyvelés';
  }
  /** Naplósorszám a könyvelőprogramok alakjában: K26/000001 (vevő), S… (szállító), P…, B…, V… */
  naplosorszam(t: any): string {
    if (!t?.sorszam) return '';
    const e = ({ vevo: 'K', szallito: 'S', penztar: 'P', bank: 'B', vegyes: 'V', nyito: 'N', zaro: 'Z' } as any)[t.naplo_tipus || this.aktivNaplo] || 'V';
    return `${e}${String(this.aktiv.ev).slice(-2)}/${String(t.sorszam).padStart(6, '0')}`;
  }
  get nezetFomenu() { return KettosComponent.CIMEK[this.nezet]?.fomenu || ''; }
  private qSub?: Subscription;
  naplok = [
    { value: 'vevo', label: 'Vevő', icon: 'person' },
    { value: 'szallito', label: 'Szállító', icon: 'business' },
    { value: 'penztar', label: 'Pénztár', icon: 'cash' },
    { value: 'bank', label: 'Bank', icon: 'card' },
    { value: 'vegyes', label: 'Vegyes', icon: 'shuffle' },
    /*  NYITÓ napló: kezdő évben nincs mit lezárni a tavalyi évből, a nyitó egyenlegeket kézzel
     *  kell felvinni – a nyitómérleg-számlával (491) szemben. Ezért a napló is választható. */
    { value: 'nyito', label: 'Nyitó', icon: 'lock-open' },
  ];
  aktivNaplo = 'szallito';

  tetelek: any[] = [];
  kivonat: any = { sorok: [], osszesen: {} };
  /*  FŐKÖNYVI KIVONAT SZŰKÍTÉSE – a közös Szűkítés ablak (kivonat-szukites) tölti. A szűrő a
   *  nézetváltás után is megmarad (ugyanazt a kimutatást szokás többször elővenni). */
  kivonatSzuro: KivonatSzuro = uresKivonatSzuro();
  kivonatSzukitesNyitva = false;
  kivonatKinyitva = new Set<string>();      // kinyitott alábontások (számlaszám)
  munkaszamok: any[] = [];
  eredmeny: any = null;
  merleg: any = null;
  /** A mérleg két hasábja EGY táblázatban, soronként párban – így a két „összesen” egy sorba kerül. */
  /*  A mérleg-objektumhoz kötve tárolva (2026-11-05): a getter eddig minden változásészleléskor új sorokat adott, az
   *  *ngFor ezért az egész mérleget újraépítette. Csak akkor számol újra, ha a `merleg` maga cserélődik. */
  /*  A kontír nézet bizonylatlistája: a legutóbbi `tetelLap` darab rajzolódik ki (a lista dátum szerint növekvő), a
   *  korábbiak gombbal – egy egész évi napló eddig egyszerre, trackBy nélkül került a DOM-ba (2026-11-05). */
  tetelLap = 200;
  private rajzoltTar: { t: any[]; lap: number; v: any[] } | null = null;
  get rajzoltTetelek(): any[] {
    const t = this.tetelek || [];
    if (this.rajzoltTar && this.rajzoltTar.t === t && this.rajzoltTar.lap === this.tetelLap) return this.rajzoltTar.v;
    const v = t.length > this.tetelLap ? t.slice(t.length - this.tetelLap) : t;
    this.rajzoltTar = { t, lap: this.tetelLap, v };
    return v;
  }
  tetelTrack = (_: number, t: any) => t?.id ?? _;
  tukorTrack = (_: number, t: any) => t?.szamlaszam ?? _;
  private merlegSorokTar: { m: any; sorok: { e: any; f: any }[] } | null = null;
  get merlegSorok(): { e: any; f: any }[] {
    if (this.merlegSorokTar && this.merlegSorokTar.m === this.merleg) return this.merlegSorokTar.sorok;
    const sorok = this.merlegSorokSzamol();
    this.merlegSorokTar = { m: this.merleg, sorok };
    return sorok;
  }
  private merlegSorokSzamol(): { e: any; f: any }[] {
    const m = this.merleg || {};
    const forr = [...(m.forrasok || []), { szamlaszam: '', nev: 'Mérleg szerinti eredmény (MSZE)', osszeg: m.eredmeny, msze: true }];
    const n = Math.max((m.eszkozok || []).length, forr.length);
    return Array.from({ length: n }, (_, i) => ({ e: (m.eszkozok || [])[i] || null, f: forr[i] || null }));
  }
  /* ÁFA-analitika szűrői (időszak az ÁFA szerinti dátumra, irány, kulcs, kereső). */
  afaSzuro: any = { tol: '', ig: '', irany: '', kulcs: '', kereso: '' };
  afaQuery(): string {
    const p = Object.entries(this.afaSzuro).filter(([, v]) => v !== '' && v != null).map(([k, v]) => `&${k}=${encodeURIComponent(String(v))}`);
    return p.join('');
  }
  async afaSzur() { this.afa = await this.get(`/afa-analitika/${this.aktiv.ugyfelId}?ev=${this.aktiv.ev}${this.afaQuery()}`); if (this.afa?.afa_gyakorisag) this.afaGyakorisag = this.afa.afa_gyakorisag; }
  afaSzuroTorles() { this.afaSzuro = { ...this.afaSzuro, irany: '', kulcs: '', kereso: '' }; this.afaSzur(); }
  /** '' = még nem választott (a választó látszik), 'ev' = teljes év, '01'…'12' = az adott hónap. */
  afaIdoszak = '';
  afaGyakorisag = 'negyedeves';   // az ügyfél ÁFA-bevallási gyakorisága (havi | negyedeves | eves)
  readonly afaNegyedek = ['I. negyedév', 'II. negyedév', 'III. negyedév', 'IV. negyedév'];
  get afaNegyedeves(): boolean { return this.afaGyakorisag === 'negyedeves'; }
  get afaEves(): boolean { return this.afaGyakorisag === 'eves'; }
  async afaGyakorisagBetolt() {
    try { const r: any = await this.get(`/afa-gyakorisag/${this.aktiv.ugyfelId}`); this.afaGyakorisag = r?.afa_gyakorisag || 'negyedeves'; }
    catch { this.afaGyakorisag = 'negyedeves'; }
  }
  readonly afaHonapok = ['Január', 'Február', 'Március', 'Április', 'Május', 'Június', 'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December'];
  async afaIdoszakValaszt(v: string) {
    this.afaIdoszak = v;
    const ev = this.aktiv.ev;
    if (v === 'ev') { this.afaSzuro.tol = `${ev}-01-01`; this.afaSzuro.ig = `${ev}-12-31`; }
    else if (v[0] === 'Q') {
      const n = Number(v.slice(1)), kezd = (n - 1) * 3 + 1, utolso = new Date(Number(ev), kezd + 2, 0).getDate();
      this.afaSzuro.tol = `${ev}-${String(kezd).padStart(2, '0')}-01`;
      this.afaSzuro.ig = `${ev}-${String(kezd + 2).padStart(2, '0')}-${String(utolso).padStart(2, '0')}`;
    } else {
      const h = Number(v), utolso = new Date(Number(ev), h, 0).getDate();
      this.afaSzuro.tol = `${ev}-${v}-01`; this.afaSzuro.ig = `${ev}-${v}-${String(utolso).padStart(2, '0')}`;
    }
    await this.afaSzur();
    await this.aranyositasElonez();   // a tárgyidőszaki ÁFA-arányosítás előnézete (hónapnál/negyedévnél)
  }
  afaHoKod(i: number) { return String(i + 1).padStart(2, '0'); }
  afaNegyedKod(i: number) { return 'Q' + (i + 1); }

  /* ── ÁFA-ARÁNYOSÍTÁS (tárgyhavi le nem vonható előzetes ÁFA; T 8693 / K 466) ──
   *  Csak konkrét tárgyhónál (nem „teljes év"). szorzó = mentes nettó bevétel / összes nettó bevétel;
   *  le nem vonható = szorzó × a 68-as bevallási sor áfatartalma. Hó végén, az ÁFA-bevalláskor. */
  aranyositas: any = null;
  aranyositasSor = '68';
  aranyositasFut = false;
  get aranyositasHonap(): boolean { return !!this.afaIdoszak && this.afaIdoszak !== 'ev'; }
  //  Az arányosítás tárgyidőszak-paramétere az ÁFA-nézet kiválasztott időszakából (negyedév 'Qn' vagy hónap).
  private aranyParam(): any {
    const v = this.afaIdoszak;
    if (v && v[0] === 'Q') return { negyedev: Number(v.slice(1)) };
    if (v && v !== 'ev') return { honap: Number(v) };
    return {};
  }
  async aranyositasElonez() {
    this.aranyositas = null;
    if (!this.aranyositasHonap || !this.aktiv.ugyfelId) return;
    const p = this.aranyParam();
    const qs = (p.negyedev ? `&negyedev=${p.negyedev}` : p.honap ? `&honap=${p.honap}` : '');
    try { this.aranyositas = await this.get(`/afa-aranyositas/${this.aktiv.ugyfelId}?ev=${this.aktiv.ev}${qs}&sor=${encodeURIComponent(this.aranyositasSor)}`); }
    catch { this.aranyositas = null; }
  }
  async aranyositasKonyvel() {
    if (!this.aranyositas || this.aranyositas.le_nem_vonhato <= 0) { this.ok('Nincs le nem vonható rész (0 Ft) ebben a hónapban.'); return; }
    const a = this.aranyositas;
    const ok = await this.megerosit('ÁFA-arányosítás könyvelése',
      `${a.idoszak || a.ev} – le nem vonható előzetes ÁFA: ${a.le_nem_vonhato.toLocaleString('hu-HU')} Ft (levonási hányad ${a.levonasi_hanyad}, a ${a.sor}. sor áfatartalma ${a.afa_68.toLocaleString('hu-HU')} Ft). Könyvelés: T ${a.le_nem_vonhato_szamla} / K ${a.afa_szamla} az időszak utolsó napjára.${a.mar_konyvelt ? ' (A meglévő arányosítás-bizonylat frissül.)' : ''}`);
    if (!ok) return;
    this.aranyositasFut = true;
    try {
      const r: any = await this.post(`/afa-aranyositas/${this.aktiv.ugyfelId}?ev=${this.aktiv.ev}`, { ...this.aranyParam(), sor: this.aranyositasSor });
      if (r.konyvelve) this.ok(`Arányosítás könyvelve: ${Number(r.le_nem_vonhato).toLocaleString('hu-HU')} Ft (${r.bizonylatszam}).`);
      else this.ok(r.uzenet || 'Nincs mit könyvelni.');
      await this.aranyositasElonez(); await this.afaSzur();
    } catch (e: any) { this.hiba(e?.error?.error || 'Az arányosítás könyvelése nem sikerült.'); }
    finally { this.aranyositasFut = false; }
  }
  afaNaploJel(r: any): string {
    const betu = ({ vevo: 'K', szallito: 'S', bank: 'B', penztar: 'P', vegyes: 'V', nyito: 'N', zaro: 'Z' } as any)[r.naplo_tipus] || '?';
    return `${betu}${String(this.aktiv.ev).slice(-2)}/${String(r.sorszam).padStart(6, '0')}`;
  }
  afa: any = null;
  tukor: any[] = [];
  beallitas: any = null;
  karton: any = null;
  partnerek: any[] = [];
  partnerSzerk: any = null;
  zarasAllapot: any = null;     // { ev, zarva, nyitva, elozo_ev_zarva, ... }

  szerk: any = null;          // bizonylat (fejléc + sorok)
  javaslatok: any[] = [];
  szlaSzerk: any = null;
  /*  SZERKESZTÉSI ZÁR (backend/szerkesztes-zar.js): a megnyitott bizonylat, számla és partner zárja –
   *  amíg más szerkeszti, nálunk csak olvasható. Szerkesztőnként egy fogantyú. */
  zarTetel: SzerkZar | null = null;
  zarSzla: SzerkZar | null = null;
  zarPartner: SzerkZar | null = null;
  private zarKor: Record<string, number> = {};
  /** Zár kérése a szerkesztőre. Ha a válasz megérkezéséig a szerkesztő már mást mutat, a késő zárat elengedjük. */
  private async zarKer(mezo: 'zarTetel' | 'zarSzla' | 'zarPartner', tipus: string, id: any, ujratolt: () => unknown) {
    this.zarEngedd(mezo);
    const kor = this.zarKor[mezo];
    const z = await this.szerkZar.foglal('naplo', tipus, id, { ujratolt });
    if (kor !== this.zarKor[mezo]) { z?.felenged(); return; }
    this[mezo] = z;
  }
  zarEngedd(mezo: 'zarTetel' | 'zarSzla' | 'zarPartner') {
    this.zarKor[mezo] = (this.zarKor[mezo] || 0) + 1;
    this[mezo]?.felenged(); this[mezo] = null;
  }
  /** Más szerkeszti – nálunk nem menthető / törölhető. */
  zarTilt(z: SzerkZar | null) { return !!z && !z.irhato; }
  afaSeged = { alap: null as number | null, kulcs: 27, fordit: false };

  // OSA / NAV (a naplófőkönyvi /api/naplo/osa* végpontokat használja, az ügyfél-id alapú)
  osaBeallitas: any = null;
  osaSzuro = { dateFrom: '', dateTo: '', direction: 'inbound' as 'inbound' | 'outbound', reszletes: true };
  osaSzamlak: any[] = [];
  osaLoading = false;
  osaKonyveltSet = new Set<string>();
  osaNezet: any = null;

  // NAV törzsadat (queryTaxpayer a saját adószámra – az OSA technikai felhasználóval; a /api/naplo/nav-torzsadat végpontok)
  navtorzs: any = null;                 // az ÉPPEN megjelenített lekérés (alapból a legfrissebb)
  torzsForrasNev = torzsForrasNev;   // template-ből hívható
  navtorzsMeta: any = { konfiguralt: false, utolso_szinkron: null, forras: 'upo', van_ugyfelkapu: false, van_osa: false };
  navtorzsHistory: any[] = [];
  navtorzsAktivId: string | null = null;
  navtorzsBetolt = false;

  /*  A NAV-törzsadat (navtorzs) objektumához kötve tárolva (2026-11-05): a getter minden változásészleléskor új
   *  mező- és táblalistát adott, az *ngFor ezért mindet újraépítette. Csak a navtorzs cseréjekor számol újra. */
  private torzsTar: { n: any; mezok: TorzsMezo[]; tablak: TorzsTabla[] } | null = null;
  private torzsKesz() {
    if (!this.torzsTar || this.torzsTar.n !== this.navtorzs) {
      this.torzsTar = { n: this.navtorzs, mezok: torzsadatMezok(this.navtorzs), tablak: torzsadatTablak(this.navtorzs) };
    }
    return this.torzsTar;
  }
  get torzsMezok(): TorzsMezo[] { return this.torzsKesz().mezok; }
  get torzsTablak(): TorzsTabla[] { return this.torzsKesz().tablak; }

  constructor(private http: HttpClient, public naplo: NaploService, private router: Router, private toast: ToastController, private alert: AlertController, private data: DataService,
              private route: ActivatedRoute, private szerkZar: SzerkZarService) {}

  /** A „Tárgyi eszközhöz” ablak bizonylata (null: zárva). */
  hozamTetel: string | null = null;
  hozamKesz() { this.hozamTetel = null; this.ok('Hozzárendelve – a Tárgyi eszköz modul Megtérülés fülén látszik.'); }
  get aktiv() { return this.naplo.aktiv; }
  private get<T = any>(p: string) { return firstValueFrom(this.http.get<T>(this.base + p)); }
  private post<T = any>(p: string, b: any) { return firstValueFrom(this.http.post<T>(this.base + p, b)); }
  private put<T = any>(p: string, b: any) { return firstValueFrom(this.http.put<T>(this.base + p, b)); }
  private del<T = any>(p: string) { return firstValueFrom(this.http.delete<T>(this.base + p)); }

  async ngOnInit() {
    await this.naplo.init();
    if (this.aktiv.konyveles_mod !== 'kettos') { this.router.navigateByUrl('/naplo/konyveles'); return; }
    let elso = true;
    this.qSub = this.route.queryParamMap.subscribe(async (q) => {
      const n = q.get('nezet') || 'kontir';
      // A partnertörzs, a NAV-kulcsok és a NAV törzsadat KÖZÖS képernyő a két könyvelési módban
      // (torzsek) – a régi kettős címek oda visznek. Az Online Számla már a könyvelőablakból nyílik.
      if (n === 'partner' || n === 'navtorzs') {
        this.router.navigate(['/naplo/torzsek'], { queryParams: { nezet: n }, replaceUrl: true });
        return;
      }
      const osaKell = n === 'osa';
      const ujNezet = (osaKell ? 'kontir' : (KettosComponent.CIMEK[n] ? n : 'kontir')) as any;
      //  Az ÁFA-analitika minden megnyitáskor rákérdez az időszakra (hónap vagy teljes év).
      if (ujNezet === 'afa' && this.nezet !== 'afa') { this.afaIdoszak = ''; this.afa = null; this.afaGyakorisagBetolt(); }
      this.nezet = ujNezet;
      await this.betolt();
      // Mélylinkek a Naplókból: `naplo=<típus>` (vevo/szallito/penztar/bank/vegyes), `tetel=<id>`
      // = a bizonylat módosítása, `uj=1` = új bizonylat abban a naplóban. Feldolgozás után levesszük.
      const nTipus = q.get('naplo'), tetel = q.get('tetel'), uj = q.get('uj');
      const vissza = q.get('vissza');
      if (vissza && vissza.startsWith('/naplo/')) this.visszaUt = vissza;
      else if (!nTipus && !tetel && !uj && !this.parameterLevetel) this.visszaUt = null;   // más úton jött ide
      this.parameterLevetel = false;
      if (this.nezet === 'kontir' && (nTipus || tetel || uj)) {
        if (nTipus && this.naplok.some((x) => x.value === nTipus) && nTipus !== this.aktivNaplo) {
          this.aktivNaplo = nTipus; await this.tetelekBetolt(); await this.ujTetel();
        }
        if (tetel) {
          await this.szerkTetel({ id: tetel });
          // A bizonylat SAJÁT naplója legyen az aktív fül (a hívó tévedhet – pl. régi hivatkozás).
          const sajat = this.szerk?.naplo_tipus;
          if (sajat && sajat !== this.aktivNaplo && this.naplok.some((x) => x.value === sajat)) { this.aktivNaplo = sajat; await this.tetelekBetolt(); }
        }
        // A paraméterek levétele újra lefuttatja a betöltést – az ne cserélje le a most megnyitott
        // bizonylatot üresre (ugyanaz a jelző, mint az OSA-ból előkészített bizonylatnál).
        this.osaElokeszitett = true;
        this.parameterLevetel = true;
        this.router.navigate([], { relativeTo: this.route, queryParams: { nezet: 'kontir' }, replaceUrl: true });
        this.urlapFokusz();
      }
      if (osaKell) {
        this.osaIndit();
        // A menüpont újra kiválasztva ismét nyissa meg (a címben ne maradjon ott a nezet=osa).
        this.router.navigate([], { relativeTo: this.route, queryParams: { nezet: 'kontir' }, replaceUrl: true });
      }
      if (elso) {
        elso = false;
        await this.tukorBetolt();   // a számlanevek (szamlaNev) minden nézetben kellenek, nem csak a Tükör fülön
        await this.partnerekBetolt();   // a bizonylat partner-választójához (nem csak a Partnerek fülön)
        await this.bevsorNevekBetolt(); // a számlasorok bevallási sorának megnevezése
      }
    });
  }
  ngOnDestroy() {
    this.qSub?.unsubscribe();
    this.zarEngedd('zarTetel'); this.zarEngedd('zarSzla'); this.zarEngedd('zarPartner');
  }

  /* ===== Partner-választó a törzsből (a bizonylat fejlécében) ===== */
  partnerKereso = '';
  async partnerekBetolt(eros = false) {
    if (!this.aktiv.ugyfelId || (!eros && this.partnerek.length)) return;
    try { this.partnerek = await this.naploGet(`/partnerek/${this.aktiv.ugyfelId}`); } catch { /* marad */ }
  }
  get szurtPartnerek() {
    const k = this.partnerKereso.trim().toLowerCase();
    if (!k) return this.partnerek.slice(0, 80);
    return this.partnerek.filter((p: any) => String(p.nev || '').toLowerCase().includes(k)
      || String(p.rovid_nev || '').toLowerCase().includes(k)
      || String(p.adoszam || '').replace(/\D/g, '').includes(k.replace(/\D/g, '') || '\u0000')).slice(0, 80);
  }
  async partnerPickerNyit() { this.partnerKereso = ''; await this.partnerekBetolt(); this.partnerPicker.present(); }
  partnerValaszt(p: any) {
    this.szerk.partner_id = p.id;
    this.szerk.partner_nev = p.rovid_nev || p.nev;
    this.szerk.partner_adoszam = p.adoszam || null;
    this.partnerPicker.dismiss();
    this.javaslatFrissit();
  }
  partnerTorles() { this.szerk.partner_id = null; this.szerk.partner_nev = ''; this.szerk.partner_adoszam = null; this.bevTanultAtvesz([]); this.bevTanultIgazit(); }

  //  ELŐLEGSZÁMLÁK a végszámlához: a 35x (adott előlegek) főkönyvre könyvelt bizonylatok, amiből
  //  választható az előlegszámla száma (a mező kézzel is írható). A végszámla partnerére szűrünk.
  elolegSzamlak: any[] = [];
  async elolegSzamlakBetolt() {
    if (!this.aktiv?.ugyfelId) { this.elolegSzamlak = []; return; }
    const p = String(this.szerk?.partner_adoszam || this.szerk?.partner_nev || '').trim();
    const tip = this.szerk?.naplo_tipus === 'vevo' ? '&tipus=vevo' : '';
    try {
      this.elolegSzamlak = (await this.get(`/eloleg-szamlak/${this.aktiv.ugyfelId}?ev=${this.aktiv.ev}${tip}${p ? '&partner=' + encodeURIComponent(p) : ''}`)) || [];
    } catch { this.elolegSzamlak = []; }
  }
  // Az OSA/PDF-ből jött partnernév egyeztetése a törzzsel (adószám elsőbbséggel, majd pontos név).
  partnerIllesztes(nev: string, adoszam?: string) {
    const ado = String(adoszam || '').replace(/\D/g, '').slice(0, 8);
    const nk = String(nev || '').trim().toLowerCase();
    if (ado.length === 8) {
      const p = this.partnerek.find((x: any) => String(x.adoszam || '').replace(/\D/g, '').slice(0, 8) === ado);
      if (p) return p;
    }
    return this.partnerek.find((x: any) => String(x.nev || '').trim().toLowerCase() === nk
      || String(x.rovid_nev || '').trim().toLowerCase() === nk) || null;
  }
  // A szerkesztett bizonylat partnere nincs a törzsben (a kontír-tanulás névre megy, ezért érdemes felvenni).
  get partnerHianyzik() { return !!(this.szerk?.partner_nev && !this.szerk?.partner_id && !this.partnerIllesztes(this.szerk.partner_nev, this.szerk.partner_adoszam)); }
  // Új partner a keresőmezőbe írt névvel (a választóból, ha nincs találat).
  async partnerLetrehozKeresobol() {
    const nev = this.partnerKereso.trim();
    if (!nev) return;
    try {
      const r: any = await this.naplo.post('/partner', { ugyfel_id: this.aktiv.ugyfelId, nev });
      await this.partnerekBetolt(true);
      const p = this.partnerek.find((x: any) => x.id === r?.id) || this.partnerIllesztes(nev);
      if (p) this.partnerValaszt(p); else this.partnerPicker.dismiss();
      this.ok('Partner létrehozva.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült létrehozni a partnert.'); }
  }
  async partnerFelvesz() {
    const nev = String(this.szerk?.partner_nev || '').trim();
    if (!nev) return;
    try {
      const r: any = await this.naplo.post('/partner', { ugyfel_id: this.aktiv.ugyfelId, nev, adoszam: this.szerk.partner_adoszam || null });
      await this.partnerekBetolt(true);
      this.szerk.partner_id = r?.id || this.partnerIllesztes(nev, this.szerk.partner_adoszam)?.id || null;
      this.ok('Partner felvéve a törzsbe.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült felvenni a partnert.'); }
  }

  // A számlatükör + beállítások betöltése (a "Megnevezés" oszlophoz – szamlaNev – és a fő számla
  // alapértékéhez – foszamlaAlap – minden nézetben kellenek, nem csak a Tükör/Beállítások fülön).
  /*  SZÁMLATÜKÖR AZ RLB-BŐL (foktorzs XLS, user 2026-10-07): előbb az eltérések (új, átnevezett, gyűjtővé
   *  váló számlák, és ami az RLB-ben nincs), jóváhagyás után az import (backend kettos.js /szamlatukor/rlb-import). */
  rlbTukorFut = false;
  async rlbTukorImport(input: HTMLInputElement) {
    const f = input.files?.[0];
    input.value = '';
    if (!f || !this.aktiv.ugyfelId) return;
    const kuld = (elonezet: boolean) => {
      const fd = new FormData(); fd.append('file', f, f.name);
      return this.post<any>(`/szamlatukor/rlb-import/${this.aktiv.ugyfelId}${elonezet ? '?elonezet=1' : ''}`, fd);
    };
    this.rlbTukorFut = true;
    try {
      const d = await kuld(true);
      const lista = (t: any[], n = 8) => t.slice(0, n).map((x) => x.szamlaszam).join(', ') + (t.length > n ? ` … (+${t.length - n})` : '');
      const sorok = [
        `${d.osszes} számla az RLB-tükörben.`,
        d.uj.length ? `Új: ${d.uj.length} (${lista(d.uj)})` : '',
        d.atnevez.length ? `Átnevezve: ${d.atnevez.length}` : '',
        d.gyujto_valt.length ? `Gyűjtő-jelölés változik: ${d.gyujto_valt.length} (${lista(d.gyujto_valt)})` : '',
        d.gyujto_konyvelt?.length ? `⚠ Gyűjtő lesz, pedig van rajta könyvelés: ${d.gyujto_konyvelt.join(', ')} – arra ezután nem lehet könyvelni.` : '',
        d.hianyzik_ures.length ? `Az RLB-ben nincs, könyvelés sincs rajta – inaktív lesz: ${d.hianyzik_ures.length}` : '',
        d.hianyzik_konyvelt.length ? `Az RLB-ben nincs, de van rajta könyvelés – marad: ${lista(d.hianyzik_konyvelt)}` : '',
      ].filter(Boolean);
      const a = await this.alert.create({ header: 'Számlatükör importálása az RLB-ből', message: sorok.join('\n'), cssClass: 'sortores-alert',
        buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Importálás', role: 'ok' }] });
      await a.present();
      if ((await a.onDidDismiss()).role !== 'ok') return;
      await kuld(false);
      await this.tukorBetolt(true);
      this.ok('A számlatükör az RLB szerint frissült.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Az import nem sikerült.'); }
    finally { this.rlbTukorFut = false; }
  }

  /** Fizetési módok (a NAV Online Számla kódjai magyarul) – a szerkesztő fejlécében. */
  readonly fizmodok = [
    { ertek: 'atutalas', cim: 'Átutalás' }, { ertek: 'keszpenz', cim: 'Készpénz' }, { ertek: 'kartya', cim: 'Bankkártya' },
    { ertek: 'utalvany', cim: 'Utalvány' }, { ertek: 'egyeb', cim: 'Egyéb' },
  ];

  async tukorBetolt(eros = false) {
    if (!this.aktiv.ugyfelId) return;
    //  A két lekérés párhuzamosan (2026-11-05 – eddig egymás után).
    await Promise.all([
      (async () => { try { if (eros || !this.tukor.length) this.tukor = await this.get(`/szamlatukor/${this.aktiv.ugyfelId}`); } catch { /* marad */ } })(),
      (async () => { try { if (eros || !this.beallitas) this.beallitas = await this.get(`/beallitas/${this.aktiv.ugyfelId}`); } catch { /* marad */ } })(),
    ]);
  }

  async betolt() {
    if (!this.aktiv.ugyfelId) return;
    const ugy = this.aktiv.ugyfelId, ev = this.aktiv.ev;
    //  Más nézetben a könyvelő ablak nem látszik (visszatérve újat nyit) – a bizonylat zárja elenged.
    if (this.nezet !== 'kontir') this.zarEngedd('zarTetel');
    if (this.nezet === 'kontir') {
      this.munkaszamBetolt();
      this.adokodokBetolt();
      //  A bizonylatlista és a számlatükör/beállítás egyszerre (az új bizonylat ez utóbbit használja).
      await Promise.all([this.tetelekBetolt(), this.tukorBetolt()]);
      // A könyvelő ablak mindig nyitva: új bizonylattal indul (kivéve, ha az OSA-ból előkészítettünk egyet).
      if (!this.szerk || !this.osaElokeszitett) await this.ujTetel();
      this.osaElokeszitett = false;
    }
    else if (this.nezet === 'kivonat') await this.kivonatBetolt();
    else if (this.nezet === 'eredmeny') this.eredmeny = await this.get(`/eredmenykimutatas/${ugy}?ev=${ev}`);
    else if (this.nezet === 'merleg') this.merleg = await this.get(`/merleg/${ugy}?ev=${ev}`);
    else if (this.nezet === 'afa') this.afa = this.afaIdoszak ? await this.get(`/afa-analitika/${ugy}?ev=${ev}${this.afaQuery()}`) : null;
    else if (this.nezet === 'tukor') this.tukor = await this.get(`/szamlatukor/${ugy}`);
    else if (this.nezet === 'osa') await this.osaInit();
    else if (this.nezet === 'navtorzs') await this.betoltNavTorzs();
    else if (this.nezet === 'partner') this.partnerek = await this.naploGet(`/partnerek/${ugy}`);
    else if (this.nezet === 'zaras') this.zarasAllapot = await this.get(`/zaras-allapot/${ugy}?ev=${ev}`);
    else if (this.nezet === 'beallitas') this.beallitas = await this.get(`/beallitas/${ugy}`);
  }

  /* ===== 4. fázis: évnyitás / évzárás ===== */
  private async megerosit(fejlec: string, uzenet: string, gomb = 'Igen'): Promise<boolean> {
    return new Promise((resolve) => {
      this.alert.create({
        header: fejlec, message: uzenet,
        buttons: [{ text: 'Mégse', role: 'cancel', handler: () => resolve(false) }, { text: gomb, handler: () => resolve(true) }],
      }).then((a) => a.present());
    });
  }

  async evzaras() {
    const ev = this.aktiv.ev;
    if (!(await this.megerosit('Évzárás', `Lezárod a(z) ${ev}. évet? A program legenerálja a záró naplót (eredményszámlák → eredményelszámolás, mérlegszámlák → zárómérleg).`, 'Évzárás'))) return;
    const r: any = await this.post(`/evzaras/${this.aktiv.ugyfelId}?ev=${ev}`, {});
    if (r?.error) return this.hiba(r.error);
    this.ok(`Évzárás kész – ${r.tetelek} záró tétel.`);
    await this.betolt();
  }

  async zarasVisszavon() {
    const ev = this.aktiv.ev;
    if (!(await this.megerosit('Zárás visszavonása', `Törlöd a(z) ${ev}. év záró naplóját?`, 'Visszavonás'))) return;
    const r: any = await this.post(`/zaras-visszavonas/${this.aktiv.ugyfelId}?ev=${ev}`, {});
    if (r?.error) return this.hiba(r.error);
    this.ok(`Zárás visszavonva (${r.torolt} tétel törölve).`);
    await this.betolt();
  }

  /** Az RLB-import ablaka (a Naplók képernyőn él) – nyitatlan évben is. */
  rlbImportNyit() { this.router.navigate(['/naplo/naplok'], { queryParams: { ful: 'penzugyi', rlbimport: '1' } }); }

  async evnyitas() {
    const ev = this.aktiv.ev;
    if (!(await this.megerosit('Évnyitás', `Megnyitod a(z) ${ev}. évet a(z) ${ev - 1}. év zárómérlegéből (nyitó napló a 491 nyitómérleg-számlával szemben)?`, 'Évnyitás'))) return;
    const r: any = await this.post(`/evnyitas/${this.aktiv.ugyfelId}?ev=${ev}`, {});
    if (r?.error) return this.hiba(r.error);
    this.ok(`Évnyitás kész – ${r.tetelek} nyitó tétel (${r.forras} → ${r.ev}).`);
    await this.betolt();
  }

  /* ===== OSA / NAV ===== */
  private naploGet<T = any>(p: string) { return this.naplo.get<T>(p); }
  private naploPost<T = any>(p: string, b: any) { return this.naplo.post<T>(p, b); }

  /** Számla behúzása a NAV-ból: a közös választó nyílik (a könyvelt számlák jelölésével). */
  async osaIndit() {
    await this.osaKonyveltBetolt();
    this.osaModal?.present();
  }
  /** A választóból: előkészített bizonylat a könyvelőablakban (a felhasználó nézi át és menti). */
  async osaValasztKonyvel(sz: any) {
    await this.osaModal?.dismiss();
    this.stornoPar = null; this.modositoPar = null;
    if (stornoE(sz)) return this.stornoKonyvel(sz);
    //  Összeggel bíró módosító: a szokásos könyvelés, és mentéskor az eredetihez kötjük.
    if (KettosComponent.modositoE(sz)) {
      await this.osaKonyvel(sz);
      if (this.szerk?.osa_szamlaszam === sz.szamlaszam) this.modositoPar = sz;
      return;
    }
    //  Az eredetire hivatkozó, még könyveletlen storno: a mentéskor vele együtt könyvelődik (0 egyenleg).
    const par = await stornoParKeres(this.naplo, this.aktiv.ugyfelId as string, sz, (x) => this.osaKonyveltSet.has(x.szamlaszam));
    await this.osaKonyvel(sz);
    if (par && this.szerk?.osa_szamlaszam === sz.szamlaszam) { this.stornoPar = par; this.stornoParJelol = true; }
  }

  /* ══════════ STORNO SZÁMLA ══════════
   *  Ha az eredeti már könyvelt: a storno egy kattintással a tükre lesz (T ↔ K, 0 egyenleg, az eredeti
   *  nyitott tételét kiegyenlíti). Ha még nincs: az eredeti nyílik meg, és a mentésével együtt a storno
   *  is lekönyvelődik. (backend: kettos.js /osa-storno) */
  stornoPar: any = null;          // a megnyitott eredeti számlához tartozó storno
  stornoParJelol = true;          // a mentéskor könyvelődjön-e vele
  private async stornoKonyvel(st: any) {
    if (this.osaKonyveltSet.has(st.eredeti_szamlaszam)) {
      const a = await this.alert.create({ header: 'Storno számla',
        message: `A(z) ${st.szamlaszam} az eredeti ${st.eredeti_szamlaszam} számla sztornója. Lekönyveljem az eredeti tükreként (ellentétes oldalon, 0 egyenlegre)?`,
        buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Könyvelés', role: 'ok' }] });
      await a.present();
      if ((await a.onDidDismiss()).role !== 'ok') return;
      return this.stornoKuld(st);
    }
    const eredeti = await eredetiKeres(this.naplo, this.aktiv.ugyfelId as string, st);
    if (!eredeti) return this.hiba(`Az eredeti számla (${st.eredeti_szamlaszam}) nincs a letöltött számlák között és nincs is lekönyvelve – előbb azt kell behúzni vagy könyvelni.`);
    this.ok(`Az eredeti számla (${eredeti.szamlaszam}) még nincs könyvelve – azt nyitom meg; a mentéskor a storno is vele együtt könyvelődik (0 egyenleg).`);
    await this.osaKonyvel(eredeti);
    if (this.szerk?.osa_szamlaszam === eredeti.szamlaszam) { this.stornoPar = st; this.stornoParJelol = true; }
  }
  private async stornoKuld(st: any): Promise<boolean> {
    try {
      const r: any = await this.post(`/osa-storno/${this.aktiv.ugyfelId}`, { storno: st, eredeti_szamlaszam: st.eredeti_szamlaszam });
      await this.osaKonyveltBetolt();
      await this.tetelekBetolt();
      this.ok(`Storno lekönyvelve (${st.szamlaszam}) – az eredeti tükreként${r?.rendezve ? `, a nyitott tételt kiegyenlítette (${Math.round(r.rendezve).toLocaleString('hu-HU')} Ft)` : ''}.`);
      return true;
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült lekönyvelni a storno számlát.'); return false; }
  }

  async osaInit() {
    const ev = this.aktiv.ev;
    if (!this.osaSzuro.dateFrom) this.osaSzuro = { dateFrom: ev + '-01-01', dateTo: ev + '-12-31', direction: this.osaSzuro.direction, reszletes: true };
    this.osaNezet = null;
    try { this.osaBeallitas = await this.naploGet(`/osa/beallitas/${this.aktiv.ugyfelId}`); } catch { this.osaBeallitas = {}; }
    await this.osaKonyveltBetolt();
    await this.osaCacheBetolt();
  }

  async osaBeallitasMent() {
    try { await this.naplo.put(`/osa/beallitas/${this.aktiv.ugyfelId}`, this.osaBeallitas || {}); this.ok('NAV-kulcsok mentve.'); }
    catch { this.hiba('Nem sikerült menteni a NAV-kulcsokat.'); }
  }
  async osaTeszt() {
    try { const r: any = await this.naploPost(`/osa/teszt/${this.aktiv.ugyfelId}`, {}); r?.ok ? this.ok('NAV-kapcsolat rendben.') : this.hiba(r?.error || 'A NAV-kapcsolat nem működik.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'A NAV-kapcsolat nem működik.'); }
  }

  /* ===== NAV törzsadat (queryTaxpayer – history + PDF; közös a /api/naplo/nav-torzsadat végpontokon) ===== */
  async betoltNavTorzs() {
    const r: any = await this.naploGet('/nav-torzsadat/' + this.aktiv.ugyfelId);
    this.navtorzsMeta = { konfiguralt: r.konfiguralt, utolso_szinkron: r.utolso_szinkron, forras: r.forras || 'upo',
      van_ugyfelkapu: !!r.van_ugyfelkapu, van_osa: !!r.van_osa };
    this.navtorzsHistory = r.history || [];
    this.navtorzs = r.torzs;
    this.navtorzsAktivId = r.aktualis_id || (this.navtorzsHistory[0]?.id ?? null);
  }

  // Törzsadat-forrás váltása (eBEV = hivatalos, gazdag | OSA = API-részhalmaz).
  async valtTorzsForras(forras: string) {
    if (!forras || forras === this.navtorzsMeta.forras) return;
    try {
      await this.naplo.put('/nav-torzsadat/beallitas/' + this.aktiv.ugyfelId, { forras });
      await this.betoltNavTorzs();
      this.ok('Törzsadat-forrás: ' + this.torzsForrasNev(forras));
    } catch (e: any) { this.hiba(e?.error?.error || 'A forrás váltása nem sikerült.'); }
  }
  async frissitNavTorzs() {
    if (!this.aktiv.ugyfelId) return;
    this.navtorzsBetolt = true;
    try {
      const r: any = await this.naploPost('/nav-torzsadat/szinkron/' + this.aktiv.ugyfelId, {});
      this.navtorzs = r.torzs;
      this.navtorzsMeta.utolso_szinkron = r.utolso_szinkron;
      this.navtorzsHistory = r.history || this.navtorzsHistory;
      this.navtorzsAktivId = r.aktualis_id || (this.navtorzsHistory[0]?.id ?? null);
      this.ok('NAV törzsadat frissítve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'A NAV törzsadat-lekérdezés nem sikerült.'); }
    finally { this.navtorzsBetolt = false; }
  }
  async valasztTorzsVerzio(id: string) {
    if (!id) return;
    this.navtorzsAktivId = id;
    try { const r: any = await this.naploGet('/nav-torzsadat/' + this.aktiv.ugyfelId + '/tetel/' + id); this.navtorzs = r.torzs; }
    catch (e: any) { this.hiba(e?.error?.error || 'A lekérés betöltése nem sikerült.'); }
  }
  get navtorzsLegfrissebb(): boolean { return !this.navtorzsHistory.length || this.navtorzsAktivId === this.navtorzsHistory[0].id; }
  async letoltNavTorzsPdf() {
    if (!this.navtorzsAktivId) return;
    try {
      const blob = await this.naplo.getBlob('/nav-torzsadat/pdf/' + this.navtorzsAktivId);
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'nav_torzsadat_' + (this.navtorzs?.adoszam || '').replace(/\D/g, '') + '.pdf';
      a.click();
      setTimeout(() => URL.revokeObjectURL(a.href), 1500);
    } catch { this.hiba('A PDF letöltése nem sikerült.'); }
  }
  navtorzsTipusCimke(t: string): string { return t === 'ceg' ? 'Cég / szervezet' : (t === 'egyeni' ? 'Egyéni vállalkozó' : (t === 'maganszemely' ? 'Adószámos magánszemély' : (t || '—'))); }
  navtorzsCimTipus(t: string): string { const u = String(t || '').toUpperCase(); return u === 'HQ' ? 'Székhely' : (u === 'SITE' ? 'Telephely' : (u === 'BRANCH' ? 'Fióktelep' : (t || 'Cím'))); }

  async osaKonyveltBetolt() {
    try {
      const r: any = await this.get(`/osa-konyvelt/${this.aktiv.ugyfelId}`);
      this.osaKonyveltSet = new Set(r.szamlaszamok || []); this.osaCsatoltSet = new Set(r.csatolt || []);
    } catch { this.osaKonyveltSet = new Set(); }
  }
  konyvelt(sz: any) { return this.osaKonyveltSet.has(sz.szamlaszam); }

  async osaCacheBetolt() {
    this.osaLoading = true; this.osaNezet = null;
    try { const r: any = await this.naploGet(`/osa/cache/${this.aktiv.ugyfelId}?direction=${this.osaSzuro.direction}`); this.osaSzamlak = r.szamlak || []; }
    catch { this.osaSzamlak = []; } finally { this.osaLoading = false; }
  }
  // Előnézet-mód: a lekérdezés eredménye NEM íródik be automatikusan – a felhasználó
  // választja ki, melyik számlát emeli be. Így korábbi évek időszaka is lekérdezhető
  // anélkül, hogy az összes régi számla bekerülne a nyilvántartásba.
  osaElonezet = false;
  osaBeemelFut = false;
  osaKijelolt = new Set<string>();

  osaKijelolValt(sz: any) {
    if (this.osaKijelolt.has(sz.szamlaszam)) this.osaKijelolt.delete(sz.szamlaszam);
    else this.osaKijelolt.add(sz.szamlaszam);
  }
  get osaKijeloltDb() { return this.osaKijelolt.size; }
  osaKijelolMind() {
    const mind = (this.osaSzamlak || []);
    if (mind.length && mind.every((s: any) => this.osaKijelolt.has(s.szamlaszam))) this.osaKijelolt.clear();
    else mind.forEach((s: any) => this.osaKijelolt.add(s.szamlaszam));
  }

  // A lekérés a SZERVEREN, háttérfeladatként fut. Egy teljes év + részletes letöltés számlánként
  // egy külön NAV-hívást jelent (percekig tarthat) – kérésen belül a böngésző rég bontana, és a
  // felhasználó "sikertelen"-t látna, miközben a szerver dolgozik. Így viszont elnavigálhatsz:
  // a fejléc alatti sáv végig mutatja a haladást, és a végén ez az oldal magától frissül.
  osaFeladatId: string | null = null;
  osaFeladatHalad: any = null;

  async osaKeres() {
    if (!this.aktiv.ugyfelId) return;
    this.osaNezet = null;
    const kertIrany = this.osaSzuro.direction;   // az elnavigálás/váltás miatt rögzítjük
    const elonezet = this.osaElonezet;
    try {
      const id = await this.naplo.feladatIndit(`/osa/digest-inditas/${this.aktiv.ugyfelId}`, {
        direction: kertIrany, dateFrom: this.osaSzuro.dateFrom, dateTo: this.osaSzuro.dateTo,
        reszletes: this.osaSzuro.reszletes, elonezet,
      });
      if (!id) { this.hiba('Nem sikerült elindítani a lekérést.'); return; }
      this.osaFeladatId = id;
      this.ok('A lekérés elindult a háttérben – nyugodtan elnavigálhatsz, a fejlécben követheted.');

      // Bevárjuk az EREDMÉNYT, hogy a lista magától frissüljön. Ha közben elnavigálsz, ez a
      // várakozás egyszerűen eldobódik – a feladat a szerveren attól még végigfut.
      const f = await this.naplo.feladatVar(id, (h) => { this.osaFeladatHalad = h; });
      this.osaFeladatId = null; this.osaFeladatHalad = null;
      if (this.osaSzuro.direction !== kertIrany) return;    // időközben irányt váltott – ne írjuk felül

      const e = f?.eredmeny || {};
      if (elonezet && Array.isArray(e.szamlak)) {
        this.osaSzamlak = e.szamlak; this.osaKijelolt.clear();
        const uj = this.osaSzamlak.filter((s: any) => !s.mar_beemelve).length;
        this.ok(`${this.osaSzamlak.length} számla az időszakban (${uj} még nincs beemelve). Jelöld ki, melyiket kéred.`);
      } else {
        // Nem előnézet: a szerver már a gyorsítótárba írta, onnan töltjük (így nagy eredménynél
        // sem kell a teljes listát a feladat mellett cipelni).
        await this.osaCacheBetolt();
        if (!this.osaSzamlak.length) this.ok('Nincs számla a megadott időszakban.');
        else this.ok(`${this.osaSzamlak.length} számla a listában.`);
      }
      if (e.hibas?.length) this.hiba(`${e.hibas.length} számla részletes adata nem jött le (a lista attól még teljes).`);
    } catch (e: any) {
      this.osaFeladatId = null; this.osaFeladatHalad = null;
      this.hiba(e?.error?.error || e?.message || 'OSA lekérés hiba.');
    }
  }

  // A kijelölt (előnézetben lévő) számlák beemelése – a NAV-tól újra lekérve, részletesen.
  async osaBeemel() {
    const szamlaszamok = Array.from(this.osaKijelolt);
    if (!szamlaszamok.length) { this.hiba('Jelöld ki, melyik számlákat emeljem be.'); return; }
    this.osaBeemelFut = true;
    try {
      const r: any = await this.naploPost(`/osa/beemel/${this.aktiv.ugyfelId}`, {
        direction: this.osaSzuro.direction === 'inbound' ? 'INBOUND' : 'OUTBOUND', szamlaszamok,
      });
      this.ok(`${r?.beemelve || 0} számla beemelve.` + (r?.hibak?.length ? ` (${r.hibak.length} sikertelen)` : ''));
      this.osaKijelolt.clear();
      this.osaElonezet = false;
      await this.osaCacheBetolt();
    } catch (e: any) { this.hiba(e?.error?.error || 'A beemelés nem sikerült.'); }
    finally { this.osaBeemelFut = false; }
  }

  // Az OSA-számlából NEM könyvel azonnal: lekéri a javasolt T/K bizonylatot (preview) és
  // felnyitja a kontírozó modalt kitöltve, hogy a felhasználó átnézze/módosítsa és ő mentse.
  /*  Az OSA-számlából összeállítja a `/osa-konyvel` törzsét (a listában hiányzó részletet – ÁFA-sorok,
   *  fizetési határidő, fizmód – a NAV /osa/data-ból pótolja). Az egy-számlás és a tömeges flow is ezt hívja. */
  private async osaBody(sz: any): Promise<{ body: any; hatarido: string | null }> {
    let afaSorok = sz.afaSorok || null;
    let hatarido = sz.fizetesi_hatarido || sz.hatarido || null;
    //  A fizetési mód a NAV-számlából (Online Számla paymentMethod) – a listában nem mindig van meg.
    let fizmod = sz.paymentMethod || sz.fizmod || null;
    if (!afaSorok || !hatarido || !fizmod) {
      const p = new URLSearchParams({ invoiceNumber: sz.szamlaszam, direction: sz.irany === 'outbound' ? 'outbound' : 'inbound' });
      const r: any = await this.naploGet(`/osa/data/${this.aktiv.ugyfelId}?${p.toString()}`).catch(() => null);
      afaSorok = afaSorok || r?.szamla?.sorok || null;
      //  A NAV paymentDate-je – a fizetési határidő (a listában régebben nem tároltuk).
      hatarido = hatarido || (r?.szamla?.paymentDate ? String(r.szamla.paymentDate).slice(0, 10) : null);
      fizmod = fizmod || r?.szamla?.paymentMethod || null;
    }
    return { body: { szamlaszam: sz.szamlaszam, irany: sz.irany, partner_nev: sz.partner_nev, partner_adoszam: sz.partner_adoszam,
      kelt: sz.kelt, teljesites: sz.teljesites, netto: sz.netto, afa: sz.afa, brutto: sz.brutto, afaSorok, fizmod }, hatarido };
  }

  /*  CSOPORTOS (tömeges) könyvelés a választóból: a kijelölt OSA-számlákat egyenként auto-kontírral
   *  könyveli – de CSAK ott, ahol a backend MEGBÍZHATÓ (tanult) kontír-javaslatot ad (`csakMegbizhato=1`);
   *  ahol nincs tanult szabály, kihagyja (a felhasználó egyenként kontírozza). Storno/módosító: kézi. */
  async osaTomeges(lista: any[]) {
    if (!lista?.length) return;
    let konyvelt = 0; let kihagyott = 0; const hibak: string[] = [];
    for (const sz of lista) {
      try {
        if (stornoE(sz) || KettosComponent.modositoE(sz)) { kihagyott++; continue; }
        const { body } = await this.osaBody(sz);
        const r: any = await this.post(`/osa-konyvel/${this.aktiv.ugyfelId}?ev=${this.aktiv.ev}&csakMegbizhato=1`, body);
        if (r?.id) konyvelt++; else kihagyott++;
      } catch (e: any) { kihagyott++; const m = e?.error?.error; if (m) hibak.push(`${sz.szamlaszam}: ${m}`); }
    }
    await this.osaKonyveltBetolt();
    await this.tetelekBetolt();
    const hibaSzov = hibak.length ? ' Hibák: ' + hibak.slice(0, 3).join('; ') : '';
    this.ok(`Csoportos könyvelés kész. Könyvelve: ${konyvelt}, kihagyva (kézi kontír kell): ${kihagyott}.${hibaSzov}`);
  }

  async osaKonyvel(sz: any) {
    try {
      const { body, hatarido } = await this.osaBody(sz);
      const r: any = await this.post(`/osa-konyvel/${this.aktiv.ugyfelId}?ev=${this.aktiv.ev}&preview=1`, body);
      if (r?.error) return this.hiba(r.error);
      const f = r.fejlec || {};
      this.aktivNaplo = f.naplo_tipus || this.aktivNaplo;
      const ki = sz.irany === 'outbound' || sz.irany === 'bevetel';
      const megnevezes = (f.megnevezes && String(f.megnevezes).trim()) || `${ki ? 'Értékesítés' : 'Beszerzés'} – ${sz.partner_nev || sz.szamlaszam}`;
      await this.tukorBetolt();
      const fl = this.bontFixLab(r.sorok || [], f.naplo_tipus);   // a partner-láb (311/4541) lesz a fix fő számla
      await this.partnerekBetolt();
      this.zarEngedd('zarTetel');   // új (még mentetlen) bizonylat – nincs zár
      this.szerk = {
        naplo_tipus: f.naplo_tipus, datum: f.datum, teljesites: f.teljesites,
        // ÁFA-teljesítés = teljesítés (magyar főszabály); a fizetési határidő az OSA-ból jön, ha van
        afa_datum: f.teljesites || f.datum, hatarido, fizmod: f.fizmod || null,
        bizonylatszam: f.bizonylatszam,
        partner_nev: f.partner_nev, partner_adoszam: f.partner_adoszam,
        partner_id: this.partnerIllesztes(f.partner_nev, f.partner_adoszam)?.id || null,
        megnevezes,
        osa_szamlaszam: f.osa_szamlaszam, osa_irany: f.osa_irany,
        foszamla: fl.foszamla || this.foszamlaAlap(f.naplo_tipus), sorok: fl.sorok.length ? fl.sorok : [this.uresSor()],
      };
      this.bizEllenoriz();
      // Magánszemély: ha az OSA nem adott partnert, kiolvassuk a számla PDF-jéből (szöveg → OCR).
      if (!this.szerk.partner_nev) {
        try {
          const pe: any = await this.naploGet(`/osa/partner-pdfbol/${this.aktiv.ugyfelId}?szamlaszam=${encodeURIComponent(sz.szamlaszam)}`);
          if (pe?.ok && pe.partner?.nev) {
            this.szerk.partner_nev = pe.partner.nev;
            this.szerk.partner_adoszam = pe.partner.adoszam || this.szerk.partner_adoszam;
            if (ki) this.szerk.megnevezes = `Értékesítés – ${pe.partner.nev}`;
            this.ok(`Vevő kiolvasva a számlából${pe.ocr ? ' (OCR)' : ''}: ${pe.partner.nev}`);
          }
        } catch { /* nincs letöltött PDF v. nem olvasható – marad üres, kézzel megadható */ }
      }
      this.javaslatok = [];
      this.osaNezet = null;
      await this.tukorBetolt();
      await this.ellenszamlaElokeszit();
      this.szamlasorokbol();
      //  A partnernél tanult bevallási sor már a behúzott számlán látsszon (az adókód-katalógus kell hozzá).
      await this.adokodokBetolt();
      this.bevTanultIgazit();
      // A könyvelő ablak a Könyvelés nézetben van: oda váltunk, az előkészített bizonylattal.
      this.osaElokeszitett = true;
      //  Adott előleg: a beérkező számlán szerepel az „előleg” szó → a jelölő magától bekapcsol.
      this.kapcsolatTorol();
      const szoveg = [f.megnevezes, sz.megnevezes, ...(this.szamlasorok || []).map((x: any) => x.megj), ...(r.sorok || []).map((x: any) => x.megjegyzes)].join(' ');
      if (r.vegszamla) await this.osaVegszamla(r.vegszamla);
      else if (/el[őoöő]leg/i.test(szoveg) && !/felhaszn|levon|besz[áa]m[íi]t/i.test(szoveg)) { this.elolegJel = true; this.elolegValt(true); this.ok(`Előlegszámla (${ki ? 'kapott' : 'adott'} előleg): az „Előleg” jelölő bekapcsolva – a bankból könyveljük, az ÁFA külön vegyes bizonylatra kerül.`); }
      this.nezetValt('kontir');
      this.urlapFokusz();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült előkészíteni a könyvelést.'); }
  }

  async osaMegnyit(sz: any) {
    try {
      const p = new URLSearchParams({ invoiceNumber: sz.szamlaszam, direction: sz.irany === 'outbound' ? 'outbound' : 'inbound' });
      const r: any = await this.naploGet(`/osa/data/${this.aktiv.ugyfelId}?${p.toString()}`);
      this.osaNezet = { ...(r.szamla || {}), szamlaszam: sz.szamlaszam, irany: sz.irany, konyvelt: this.konyvelt(sz), nav_pdf_id: sz.nav_pdf_id, dok_pdf_id: sz.dok_pdf_id };
    } catch { this.hiba('Nem sikerült lekérni a számla adatait.'); }
  }
  osaNezetZar() { this.osaNezet = null; }

  //  Számlakép: ELŐBB A CSATOLT EREDETI kép (dokumentumtár / számlázóprogram / letöltött NAV Számlázó –
  //  a backend szamlaKepBiztos adja, fantomlink-kitakarítással); csak ha nincs ilyen, akkor a GENERÁLT
  //  (nyomtatható) nézet. Korábban mindig csak a generált nézet jött, a csatolt eredeti sosem.
  async osaSzamlakep(sz: any) {
    const w = window.open('', 'szamlakep', 'width=820,height=900,scrollbars=yes');
    if (w) w.document.write('<p style="font-family:sans-serif;padding:20px">Számlakép betöltése…</p>');
    const u = this.aktiv.ugyfelId;
    try {
      const ir = sz.irany === 'outbound' ? 'outbound' : 'inbound';
      const blob = await this.naplo.getBlob(`/nav/szamlazo/pdf-szamlaszam/${u}?szamlaszam=${encodeURIComponent(sz.szamlaszam)}&irany=${ir}`);
      if (blob && blob.size) { if (w) w.location.href = URL.createObjectURL(blob); return; }
    } catch { /* nincs csatolt eredeti → generált nézetre esünk vissza */ }
    try {
      const p = new URLSearchParams({ szamlaszam: sz.szamlaszam, direction: sz.irany === 'outbound' ? 'outbound' : 'inbound' });
      const r: any = await this.naploGet(`/osa/szamlakep/${u}?${p.toString()}`);
      szamlakepAblakba(w, r.szamla);
    } catch (e: any) { if (w) w.close(); this.hiba(e?.error?.error || 'Számlakép letöltése sikertelen.'); }
  }
  navPdfMegnyit(navPdfId: string) { if (navPdfId) this.data.megnyitFajl('/api/naplo/nav/szamlazo/pdf/' + navPdfId, 'NAV számla PDF'); }
  tetelKep(t: any) { if (t?.id) this.data.megnyitFajl('/api/kettos/kep/' + t.id, 'Számlakép'); }
  // Módosító/storno számla → az eredeti számla képének megnyitása.
  osaEredetiNyit(s: any) { if (s?.eredeti_szamlaszam) this.osaSzamlakep({ szamlaszam: s.eredeti_szamlaszam, irany: s.irany }); }
  eredetiCsoport(s: any) { return s?.eredeti_szamlaszam || (s?.muvelet && s.muvelet !== 'CREATE' ? '—' : ''); }
  dokPdfMegnyit(dokId: string) { if (dokId) this.data.megnyitFajl('/api/naplo/dokumentum/pdf/' + dokId, 'Számlakép'); }

  private fmt(n: any) { const x = Number(n); return Number.isFinite(x) ? x.toLocaleString('hu-HU') : ''; }
  // Egy különálló, igényes HTML-számlaképet ír a megnyitott ablakba (azonos az egyszeres nézettel).

  /**
   *  KÉZI NYITÓ NAPLÓ (kezdő évben). Nincs előző év, amit le lehetne zárni, ezért a nyitó
   *  egyenlegeket a könyvelő viszi fel: a nyitó naplóba, a nyitómérleg-számlával (491) szemben.
   *  Innen csak átvisszük a könyvelőablakba, előkészített fejléccel.
   */
  async keziNyitoIndit() {
    this.aktivNaplo = 'nyito';
    this.nezet = 'kontir';
    await this.tetelekBetolt();
    await this.ujTetel();
    const ev = this.aktiv.ev;
    this.szerk.datum = `${ev}-01-01`;
    this.szerk.teljesites = this.szerk.datum;
    this.szerk.afa_datum = this.szerk.datum;
    this.szerk.megnevezes = `Nyitó egyenleg ${ev}`;
    this.szerk.bizonylatszam = `NYITO-${ev}`;
    this.szerk.foszamla = this.zarasAllapot?.nyito_szamla || this.beallitas?.nyito_szamla || '491';
    this.urlapFokusz();
    this.ok('Nyitó napló: vidd fel az egyenlegeket a nyitómérleg-számlával szemben.');
  }

  /* ══════════ NYITÓ NAPLÓ IMPORTÁLÁSA TÁBLÁZATBÓL ══════════
   *  A korábbi program pontosan ezt a listát adja ki (xls/xlsx/csv), ezért nem kell soronként
   *  bevinni. Előbb ELŐNÉZET: mi jönne létre, egyensúlyban van-e, mi hiányzik a számlatükörből –
   *  és csak külön kattintásra könyvelünk. */
  nyitoImport: any = null;
  nyitoFajl: File | null = null;
  nyitoFut = false;

  async nyitoFajlValt(ev: Event) {
    const f = (ev.target as HTMLInputElement)?.files?.[0];
    (ev.target as HTMLInputElement).value = '';
    if (!f) return;
    this.nyitoFajl = f;
    await this.nyitoElonezet();
  }

  private async nyitoKuld(query: string) {
    const fd = new FormData();
    fd.append('file', this.nyitoFajl as File);
    return firstValueFrom(this.http.post<any>(`/api/kettos/nyito-import/${this.aktiv.ugyfelId}?ev=${this.aktiv.ev}${query}`, fd));
  }

  async nyitoElonezet() {
    if (!this.nyitoFajl) return;
    this.nyitoFut = true;
    try { this.nyitoImport = await this.nyitoKuld(''); }
    catch (e: any) { this.nyitoImport = null; this.hiba(e?.error?.error || 'Nem sikerült beolvasni a táblázatot.'); }
    finally { this.nyitoFut = false; }
  }

  async nyitoKonyvel() {
    if (!this.nyitoImport?.sorok?.length) return;
    this.nyitoFut = true;
    try {
      const r: any = await this.nyitoKuld(`&konyvel=1${this.nyitoImport.mar_nyitva ? '&felulir=1' : ''}`);
      this.nyitoImport = null; this.nyitoFajl = null;
      await this.betolt();
      this.zarasAllapot = await this.get(`/zaras-allapot/${this.aktiv.ugyfelId}?ev=${this.aktiv.ev}`);
      this.ok(`${r?.tetelek || 0} nyitó tétel könyvelve (T ${Number(r?.tartozik || 0).toLocaleString('hu-HU')} = K ${Number(r?.kovetel || 0).toLocaleString('hu-HU')}).`);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült könyvelni a nyitó naplót.'); }
    finally { this.nyitoFut = false; }
  }

  async nyitasVisszavon() {
    const ev = this.aktiv.ev;
    if (!(await this.megerosit('Nyitás visszavonása', `Törlöd a(z) ${ev}. év nyitó naplóját?`, 'Visszavonás'))) return;
    const r: any = await this.post(`/nyitas-visszavonas/${this.aktiv.ugyfelId}?ev=${ev}`, {});
    if (r?.error) return this.hiba(r.error);
    this.ok(`Nyitás visszavonva (${r.torolt} tétel törölve).`);
    await this.betolt();
  }

  /* ===== Főkönyvi kivonat: szűkítés ===== */
  async kivonatBetolt() {
    if (!this.aktiv.ugyfelId) return;
    this.kivonat = await this.get(`/fokonyvi-kivonat/${this.aktiv.ugyfelId}?${kivonatQuery(this.kivonatSzuro, this.aktiv.ev)}`);
  }
  munkaszamNev(kod: string): string { const m = this.munkaszamok.find((x: any) => x.kod === kod); return m?.nev || ''; }
  async munkaszamBetolt() {
    try { this.munkaszamok = await this.get(`/munkaszamok/${this.aktiv.ugyfelId}`); } catch { this.munkaszamok = []; }
  }
  async kivonatMindValt(v: boolean) { this.kivonatSzuro = { ...this.kivonatSzuro, mind: v }; await this.kivonatBetolt(); }
  kivonatSzukitesNyit() { this.kivonatSzukitesNyitva = true; }
  async kivonatSzukit(sz: KivonatSzuro) {
    this.kivonatSzuro = { ...sz, mind: this.kivonatSzuro.mind };
    this.kivonatSzukitesNyitva = false;
    this.kivonatKinyitva.clear();
    await this.kivonatBetolt();
  }
  async kivonatSzuroTorol() {
    this.kivonatSzuro = { ...uresKivonatSzuro(), mind: this.kivonatSzuro.mind };
    this.kivonatKinyitva.clear();
    await this.kivonatBetolt();
  }
  get kivonatSzuroCimkek(): string[] { return kivonatCimkek(this.kivonatSzuro); }
  //  Oszlop-elrendezés a szerver által ténylegesen alkalmazott szűrő szerint.
  get kivonatNyolc(): boolean { return !!this.kivonat?.szuro?.elozo; }
  get kivonatDeviza(): boolean { return !!this.kivonat?.szuro?.deviza_ertek; }
  kivonatKinyit(r: any, e?: Event) {
    e?.stopPropagation();
    if (this.kivonatKinyitva.has(r.szamlaszam)) this.kivonatKinyitva.delete(r.szamlaszam);
    else this.kivonatKinyitva.add(r.szamlaszam);
  }

  // Főkönyvi karton egy számlára (a kivonat sorára kattintva).
  async kartonNyit(szamlaszam: string) {
    if (!szamlaszam) return;
    this.karton = await this.get(`/fokonyvi-karton/${this.aktiv.ugyfelId}?ev=${this.aktiv.ev}&szamla=${szamlaszam}`);
  }
  kartonZar() { this.karton = null; }
  /*  NYITATLAN ÉV: a felület lezárja magát. A kézi nyitó rögzítése közben nem szabad átlépni
   *  másik naplóba vagy nézetbe – addig ott sincs értelmes adat, és a félkész nyitó is elveszne.
   *  Csak a NYITÓ napló és a Nyitás / zárás nézet marad (meg a számlatükör, mert a nyitó
   *  egyenlegekhez kellhet új számla). */
  get nyitasKell(): boolean { return this.naplo.nyitasKell; }
  private static readonly NYITATLAN_NEZETEK = new Set(['zaras', 'tukor', 'beallitas']);
  nezetTiltott(n: string): boolean { return this.nyitasKell && !KettosComponent.NYITATLAN_NEZETEK.has(String(n)); }
  naploTiltott(n: string): boolean { return this.nyitasKell && String(n) !== 'nyito'; }

  nezetValt(n: any) {
    if (this.nezetTiltott(n)) { this.hiba(`Előbb nyisd meg a(z) ${this.aktiv.ev}. évet (Nyitás / zárás).`); return; }
    this.router.navigate([], { relativeTo: this.route, queryParams: { nezet: n } });
  }
  async naploValt(n: string) {
    if (this.naploTiltott(n)) { this.hiba(`Amíg az év nincs megnyitva, csak a nyitó napló rögzíthető.`); return; }
    this.aktivNaplo = n; await this.tetelekBetolt(); await this.ujTetel();
  }

  async tetelekBetolt() {
    this.tetelek = await this.get(`/tetelek/${this.aktiv.ugyfelId}?ev=${this.aktiv.ev}&naplo=${this.aktivNaplo}`);
  }

  // --- kontírozás ---
  // Egy sor = EGY könyvelési láb: FŐKÖNYVI SZÁM + összeg + T/K oldal (soronként szabad) + megnevezés.
  uresSor() { return { szamlaszam: '', megnevezes: '', osszeg: null, afa_kulcs: null, oldal: this.alapSorOldal() }; }
  // A sorok alapértelmezett oldala (a FŐLÁB-bal szemben): vevőnél Követel (bevétel), különben Tartozik (költség).
  alapSorOldal(t = this.szerk?.naplo_tipus || this.aktivNaplo) { return t === 'vevo' ? 'K' : 'T'; }
  // A napló FIX FŐLÁBA (fő számla): vevő→311, szállító→4541, pénztár→381, bank→384 (a beállításokból); vegyes→üres.
  // DEVIZÁS bizonylatnál a deviza-partnerszámla (RLB: 317 külföldi követelés / 4542 külföldi szállító),
  // ha az ügyfélnél be van állítva – különben marad a forintos.
  foszamlaAlap(t: string, devizas = false) {
    const b = this.beallitas || {};
    if (devizas) { const d = ({ vevo: b.deviza_vevo_szamla, szallito: b.deviza_szallito_szamla } as any)[t]; if (d) return d; }
    return ({ vevo: b.vevo_szamla, szallito: b.szallito_szamla, penztar: b.penztar_szamla, bank: b.bank_szamla } as any)[t] || '';
  }
  // Meglévő/OSA teljes T/K sorok → fix főláb + egy-összegű sorok (mindegyik a SAJÁT T/K oldalával).
  bontFixLab(teljes: any[], naploTipus: string) {
    const fix = this.foszamlaAlap(naploTipus);
    let idx = teljes.findIndex((s) => String(s.szamlaszam) === String(fix));
    // Pénztár / bank napló: a fő láb a pénzszámla (38x) – a banki bizonylat a bankszámla SAJÁT
    // főkönyvi számával készül (pl. 3844), ami eltérhet a beállítás alapértelmezésétől.
    if (idx < 0 && (naploTipus === 'bank' || naploTipus === 'penztar')) idx = teljes.findIndex((s) => String(s.szamlaszam).startsWith('38'));
    if (idx < 0 && (naploTipus === 'vevo' || naploTipus === 'szallito')) idx = teljes.findIndex((s) => String(s.szamlaszam).startsWith(naploTipus === 'vevo' ? '3' : '4') && (naploTipus === 'szallito' ? (Number(s.kovetel) || 0) > 0 : (Number(s.tartozik) || 0) > 0));
    const sor = (s: any) => ({ szamlaszam: s.szamlaszam, megnevezes: s.megjegyzes || '', osszeg: (Number(s.tartozik) || 0) || (Number(s.kovetel) || 0) || null, afa_kulcs: s.afa_kulcs, oldal: (Number(s.tartozik) || 0) > 0 ? 'T' : 'K',
      afa_kod: s.afa_kod || null, bevallas_sor: s.bevallas_sor || null, osszesito: s.osszesito || null,
      adokod: s.adokod || null, fordit_jogcim: s.fordit_jogcim || null, munkaszam: s.munkaszam || null,
      levonhato_arany: s.levonhato_arany != null ? Number(s.levonhato_arany) : null });
    if (idx >= 0) return { foszamla: teljes[idx].szamlaszam, sorok: teljes.filter((_, i) => i !== idx).map(sor) };
    return { foszamla: fix || '', sorok: teljes.map(sor) };
  }
  /*  KÜLÖNLEGES KONTÍR – ADOTT ELŐLEG ÉS VÉGSZÁMLA (kettos.js kapcsoltLepesekMent).
   *   Előleg (jelölő): a fő bizonylat a BANKI: T előleg-számla (383) / K bank (384X), bruttóban, 0 ÁFA-val;
   *     mellette vegyes T 466 / K 3572 az ÁFA-tartalommal (ÁFA-mentes cégnél nincs: minden bruttó).
   *   Végszámla (az Előlegszámla mező kitöltve): a fő bizonylat a szokásos szállítói (K 454X, T 466, T 5XX),
   *     mellette T 454X / K 383 az előleg bruttója és vegyes T 3572 / K 466 az előleg ÁFA-ja.
   *   A lépések a fő bizonylattal mentődnek, a módosító ablak visszatölti őket. */
  elolegJel = false;
  elolegKapott = false;                // vevői (kapott) előleg: T 384X / K 453, vegyes T 3571 / K 467
  lepesek: any[] = [];
  kapcsolatSzerep: 'eloleg' | 'vegszamla' | null = null;
  kapcsoltFo: any = null;              // ha egy LÉPÉS bizonylata nyílt meg: a fő bizonylat
  private elolegElotte: any = null;    // a jelölő bekapcsolása előtti állapot (kikapcsoláskor vissza)
  private kapcsolatVolt = false;       // a betöltött bizonylatnak voltak lépései (mentéskor törölni kell, ha elfogytak)
  /*  Az előleg BANKI bizonylat: a jelölő bekapcsolásakor a kontírozó a Bank naplóra vált (a fejléc, a lista és a
   *  sorszám is a banké), mentés után vissza az előző naplóra (pl. Vevő – onnan folyt a könyvelés). Korábban a
   *  Vevő/Szállító nézetben maradt, és a mentett előleg „egyik naplóban sem” látszott (user, 2026-11-03). */
  private elolegNaploElotte: string | null = null;
  private lepesSor(szamlaszam: string, oldal: 'T' | 'K', osszeg: number, afa_kulcs: any = null) { return { szamlaszam: String(szamlaszam || ''), oldal, osszeg: Math.round(osszeg), afa_kulcs }; }
  lepesOldal(l: any, o: 'T' | 'K') { return (l.sorok || []).filter((s: any) => s.oldal === o).reduce((a: number, s: any) => a + (Number(s.osszeg) || 0), 0); }
  lepesEgyensuly(l: any) { const t = this.lepesOldal(l, 'T'); return t > 0 && Math.round(t) === Math.round(this.lepesOldal(l, 'K')); }
  private kapcsolatTorol() { this.elolegNaploElotte = null; this.elolegJel = false; this.elolegKapott = false; this.lepesek = []; this.kapcsolatSzerep = null; this.kapcsoltFo = null; this.elolegElotte = null; this.kapcsolatVolt = false; }
  /** A számla bruttója, ÁFA-ja és (az első áfás sor) kulcsa – a számlasorokból, ennek híján a kontírból. */
  private szamlaOsszegek() {
    const sorok = (this.szamlasorok || []).filter((x: any) => Number(x.brutto) || Number(x.netto));
    if (this.szamlasoros && sorok.length) {
      const brutto = sorok.reduce((a: number, x: any) => a + (Number(x.brutto) || 0), 0);
      const afa = sorok.reduce((a: number, x: any) => a + (Number(x.afa) || 0), 0);
      const k = sorok.find((x: any) => Number(x.afa) > 0);
      return { brutto, afa, kulcs: k ? (Number(k.afa_kulcs ?? k.afa_v) || null) : null };
    }
    return { brutto: this.foOsszeg, afa: 0, kulcs: null };
  }
  elolegValt(be: boolean) {
    if (!this.szerk) return;
    if (!be) {
      if (this.elolegElotte) { const e = this.elolegElotte; this.szerk = e.szerk; this.szamlasorok = e.szamlasorok; this.ful = e.ful; this.kontirKezi = e.kontirKezi; }
      this.lepesek = []; this.kapcsolatSzerep = null; this.elolegElotte = null;
      if (this.elolegNaploElotte && this.aktivNaplo !== this.elolegNaploElotte) { this.aktivNaplo = this.elolegNaploElotte; this.tetelekBetolt(); }
      this.elolegNaploElotte = null;
      return;
    }
    if (this.aktivNaplo !== 'bank') { this.elolegNaploElotte = this.aktivNaplo; this.aktivNaplo = 'bank'; this.tetelekBetolt(); }
    this.elolegElotte = { szerk: JSON.parse(JSON.stringify(this.szerk)), szamlasorok: JSON.parse(JSON.stringify(this.szamlasorok || [])), ful: this.ful, kontirKezi: this.kontirKezi };
    const b = this.beallitas || {};
    const o = this.szamlaOsszegek();
    const afa = this.afasTetelLehet ? Math.round(o.afa) : 0;     // ÁFA-mentes cégnél nincs ÁFA-kontír: minden bruttó
    const biz = this.szerk.bizonylatszam || '';
    //  KAPOTT előleg (vevői oldal): bank T 384X / K 453 bruttó, vegyes T 3571 / K 467 az ÁFA-val.
    this.elolegKapott = this.szerk.naplo_tipus === 'vevo';
    //  A bank főlába könyvelhető 384X legyen: ha a beállított bankszámla gyűjtő (pl. 384), az első alszámlája.
    let bank = this.foszamlaAlap('bank') || '3841';
    if ((this.tukor || []).some((t: any) => t.szamlaszam === bank && t.gyujto)) {
      bank = (this.tukor || []).find((t: any) => !t.gyujto && String(t.szamlaszam).startsWith(bank))?.szamlaszam || bank;
    }
    this.szerk = { ...this.szerk, naplo_tipus: 'bank', foszamla: bank,
      sorok: [this.elolegKapott
        ? { ...this.uresSor(), szamlaszam: String(b.eloleg_kapott_szamla || '453'), megnevezes: 'Kapott előleg', osszeg: Math.round(o.brutto), oldal: 'K' }
        : { ...this.uresSor(), szamlaszam: String(b.eloleg_adott_szamla || '383'), megnevezes: 'Adott előleg', osszeg: Math.round(o.brutto), oldal: 'T' }] };
    this.kapcsolatSzerep = 'eloleg';
    this.lepesek = afa > 0 ? [{ szerep: 'eloleg_afa', naplo_tipus: 'vegyes', megnevezes: `Előleg ÁFA-ja${biz ? ' – ' + biz : ''}`,
      sorok: this.elolegKapott
        ? [this.lepesSor(b.eloleg_kapott_afa_szamla || '3571', 'T', afa), this.lepesSor(b.afa_fizetendo || '467', 'K', afa, o.kulcs)]
        : [this.lepesSor(b.afa_elozetes || '466', 'T', afa, o.kulcs), this.lepesSor(b.eloleg_afa_szamla || '3572', 'K', afa)] }] : [];
    this.kontirKezi = true;
    this.ful = 'kontir';
  }
  /** Végszámla: az Előlegszámla mező kitöltésekor a beszámítás lépései a lekönyvelt előleg adataiból. */
  async vegszamlaElolegValt() {
    if (!this.szerk || this.elolegJel || !['szallito', 'vevo'].includes(this.szerk.naplo_tipus)) return;
    const vevo = this.szerk.naplo_tipus === 'vevo';
    const szam = String(this.szerk.eloleg_szamlaszam || '').trim();
    if (!szam) { if (this.kapcsolatSzerep === 'vegszamla') { this.lepesek = []; this.kapcsolatSzerep = null; } return; }
    let adat: any = null;
    try { adat = await this.get(`/eloleg-adat/${this.aktiv.ugyfelId}?szam=${encodeURIComponent(szam)}${vevo ? '&tipus=vevo' : ''}`); } catch { adat = null; }
    if (!adat) { this.hiba(`A(z) ${szam} előlegszámla könyvelése nem található – a beszámítás lépései nem készültek el.`); return; }
    this.vegszamlaLepesekEpit(szam, adat);
  }
  /*  VÉGSZÁMLA ELŐLEGBŐL (user, 2026-11-03):
   *   kapott: főláb T 311, 1. tétel K 911 nettó + K 467 ÁFA, 2. tétel T 453 / K 311 bruttó (ÁFA nélkül) – mind a
   *           VEVŐI bizonylatban; vegyes: T 467 / K 3571 az előleg ÁFA-ja;
   *   adott:  főláb K 454X, 1. tétel T 511 + T 466, 2. tétel T 454X / K 383 bruttó – a SZÁLLÍTÓI bizonylatban;
   *           vegyes: T 3572 / K 466.
   *  A 2. tétel lépés-kártyaként látszik („a végszámla bizonylatában”, naplo_tipus 'fo'), mentéskor a fő bizonylat
   *  soraiba kerül „Előleg beszámítása” megjegyzéssel (ebből ismeri fel a visszatöltés és a nyitott tétel).
   *  `adat`: { brutto, afa, afa_kulcs, szamla (az előleg számlája), forras }. */
  private vegszamlaLepesekEpit(szam: string, adat: any) {
    const vevo = this.szerk.naplo_tipus === 'vevo';
    const b = this.beallitas || {};
    const fo = this.szerk.foszamla || this.foszamlaAlap(this.szerk.naplo_tipus);
    const afa = this.afasTetelLehet ? Math.round(Number(adat.afa) || 0) : 0;
    const br = Number(adat.brutto) || 0;
    this.kapcsolatSzerep = 'vegszamla';
    const beszamitas = { szerep: 'eloleg_beszamitas', naplo_tipus: 'fo', megnevezes: `${BESZAMITAS_JEL} – ${szam}`,
      sorok: vevo
        ? [this.lepesSor(adat.szamla || b.eloleg_kapott_szamla || '453', 'T', br), this.lepesSor(fo, 'K', br)]
        : [this.lepesSor(fo, 'T', br), this.lepesSor(adat.szamla || b.eloleg_adott_szamla || '383', 'K', br)] };
    const afaVissza = afa > 0 ? [{ szerep: 'eloleg_afa_vissza', naplo_tipus: 'vegyes', megnevezes: `Előleg ÁFA-jának visszavezetése – ${szam}`,
      sorok: vevo
        ? [this.lepesSor(b.afa_fizetendo || '467', 'T', afa, adat.afa_kulcs), this.lepesSor(b.eloleg_kapott_afa_szamla || '3571', 'K', afa)]
        : [this.lepesSor(b.eloleg_afa_szamla || '3572', 'T', afa), this.lepesSor(b.afa_elozetes || '466', 'K', afa, adat.afa_kulcs)] }] : [];
    this.lepesek = [beszamitas, ...afaVissza];
    if (vevo && adat.forras && adat.forras !== 'eloleg' && adat.forras !== 'szamla' && this.afasTetelLehet) this.ok('Régi előleg: az ÁFA-ja nem ismert – ha volt, a visszavezetés lépését kézzel vedd fel.');
    if (!vevo && adat.forras === '35x' && this.afasTetelLehet) this.ok('Régi (35x) előleg: az ÁFA-ja nem ismert – ha volt, a visszavezetés lépését kézzel vedd fel.');
  }
  /** A végszámla saját bizonylatába kerülő beszámítás (2. tétel) bruttója – a nyitott tételt ez csökkenti. */
  private foBeszamitas(): number {
    return this.lepesek.filter((l) => l.naplo_tipus === 'fo').reduce((a, l) => a + this.lepesOldal(l, 'T'), 0);
  }
  /*  Online számlából könyvelt ELŐLEGET FELHASZNÁLÓ VÉGSZÁMLA (kettos.js vegszamlaElolegLevonas): a fő bizonylat
   *  már a teljes összeg; a beszámítás összegei a számla levonó sorából jönnek, az előleg számlája (383 / 35x /
   *  453) a lekönyvelt előlegből, ha megtaláljuk. Akkor is működik, ha a végszámla végösszege 0 Ft. */
  private async osaVegszamla(v: any) {
    const szam = String(v.eloleg_szamlaszam || '').trim();
    this.szerk.eloleg_szamlaszam = szam;
    let konyvelt: any = null;
    if (szam) {
      try { konyvelt = await this.get(`/eloleg-adat/${this.aktiv.ugyfelId}?szam=${encodeURIComponent(szam)}${this.szerk.naplo_tipus === 'vevo' ? '&tipus=vevo' : ''}`); } catch { konyvelt = null; }
    }
    this.vegszamlaLepesekEpit(szam || 'előleg', { brutto: v.brutto, afa: v.afa, afa_kulcs: v.afa_kulcs, szamla: konyvelt?.szamla || null, forras: 'szamla' });
    this.ok(`Előleget felhasználó végszámla: a teljes összeget könyveljük, az előleg (${Math.round(v.brutto).toLocaleString('hu-HU')} Ft${szam ? ', ' + szam : ''}) beszámítása a bizonylat 2. tétele, az ÁFA-ja külön vegyes lépés.`
      + (szam && !konyvelt ? ' Az előleg könyvelését nem találtam – az előleg számláját ellenőrizd.' : ''));
  }
  /** A mentéshez: a lépések T/K sorokká. Nincs lépés és nem is volt → undefined (nem küldjük). */
  private kapcsolodoKuldes() {
    const kulon = this.lepesek.filter((l) => l.naplo_tipus !== 'fo');   // a 2. tétel a fő bizonylat sora, nem külön bizonylat
    if (!kulon.length && !this.kapcsolatVolt) return undefined;
    return kulon.map((l) => ({ szerep: l.szerep, naplo_tipus: l.naplo_tipus, megnevezes: l.megnevezes, datum: l.datum || this.szerk.datum,
      bizonylatszam: this.kapcsolatSzerep === 'vegszamla' ? (this.szerk.eloleg_szamlaszam || this.szerk.bizonylatszam) : this.szerk.bizonylatszam,
      sorok: l.sorok.filter((s: any) => s.szamlaszam && Number(s.osszeg)).map((s: any) => ({ szamlaszam: s.szamlaszam,
        tartozik: s.oldal === 'T' ? Number(s.osszeg) : 0, kovetel: s.oldal === 'K' ? Number(s.osszeg) : 0, afa_kulcs: s.afa_kulcs ?? null })) }));
  }
  /** Betöltött bizonylat: a kapcsolt lépések vissza a panelbe; LÉPÉS bizonylatánál a fő bizonylat jelzése. */
  private kapcsolatBetolt(teljes: any) {
    this.kapcsolatTorol();
    const tagok: any[] = teljes.kapcsolodo || [];
    if (!teljes.kapcsolat_id) return;
    if (['eloleg', 'vegszamla'].includes(teljes.kapcsolat_szerep)) {
      this.kapcsolatSzerep = teljes.kapcsolat_szerep;
      this.elolegJel = teljes.kapcsolat_szerep === 'eloleg';
      //  Kapott előleg: a banki bizonylat előleg-lába K oldalon áll (adottnál T).
      this.elolegKapott = this.elolegJel && (this.szerk?.sorok || []).some((s: any) => s.oldal === 'K');
      this.kapcsolatVolt = true;
      this.lepesek = tagok.map((g) => ({ szerep: g.kapcsolat_szerep, naplo_tipus: g.naplo_tipus, megnevezes: g.megnevezes, datum: g.datum,
        sorok: (g.sorok || []).map((s: any) => this.lepesSor(s.szamlaszam, Number(s.tartozik) > 0 ? 'T' : 'K', (Number(s.tartozik) || 0) || (Number(s.kovetel) || 0), s.afa_kulcs)) }));
    } else {
      this.kapcsoltFo = tagok.find((g) => ['eloleg', 'vegszamla'].includes(g.kapcsolat_szerep)) || null;
    }
  }

  /*  BIZONYLATSZÁM-ELLENŐRZÉS gépelés közben (kettos.js /bizonylat-ellenoriz): ha ilyen számú bizonylatot már
   *  könyveltek (a banki/pénztári kifizetést nem számítva), a mező alatt azonnal megjelenik, hol. */
  bizDupla: any[] = [];
  private bizIdozito: any = null;
  private static readonly NAPLO_NEV: Record<string, string> = { szallito: 'Szállítói', vevo: 'Vevői', vegyes: 'Vegyes', nyito: 'Nyitó', zaro: 'Záró' };
  naploNevBiz(t: string) { return KettosComponent.NAPLO_NEV[t] || t; }
  bizEllenoriz() {
    clearTimeout(this.bizIdozito);
    const szam = String(this.szerk?.bizonylatszam || '').trim();
    if (szam.length < 2 || !this.aktiv.ugyfelId) { this.bizDupla = []; return; }
    this.bizIdozito = setTimeout(async () => {
      try {
        const r: any = await this.get(`/bizonylat-ellenoriz/${this.aktiv.ugyfelId}?szam=${encodeURIComponent(szam)}&kizar=${encodeURIComponent(this.szerk?.id || '')}`);
        if (String(this.szerk?.bizonylatszam || '').trim() === szam) this.bizDupla = r?.talalatok || [];
      } catch { this.bizDupla = []; }
    }, 350);
  }

  async ujTetel() {
    const ma = this.datStr(new Date(this.aktiv.ev, new Date().getMonth(), new Date().getDate()));
    this.zarEngedd('zarTetel');   // új (még mentetlen) bizonylat – nincs zár
    // Négy dátum: kelt (datum), teljesítés, ÁFA-teljesítés, fizetési határidő – alapból egybeesnek.
    this.szerk = { naplo_tipus: this.aktivNaplo, datum: ma, teljesites: ma, afa_datum: ma, hatarido: ma, bizonylatszam: '', partner_nev: '', partner_id: null, megnevezes: '', munkaszam: '', eloleg_szamlaszam: '', eredeti_bizonylatszam: '',
      foszamla: this.foszamlaAlap(this.aktivNaplo), sorok: [this.uresSor()] };
    this.bizDupla = [];
    this.kapcsolatTorol();
    this.javaslatok = [];
    this.forditTorol();
    await this.tukorBetolt();
    await this.ellenszamlaElokeszit();
    this.szamlasorok = [this.ujSzamlasor()];
    this.kontirKezi = false;
    this.ful = this.szamlasoros ? 'szamlasor' : 'kontir';
  }
  async szerkTetel(t: any) {
    //  A szerkesztési zárat a betöltéssel párhuzamosan kérjük; ha a betöltés nem sikerül, elengedjük.
    this.zarKer('zarTetel', 'kettos_tetel', t.id, () => this.tetelUjratolt(String(t.id)));
    const kor = this.zarKor['zarTetel'];
    try { await this.tetelBetolt(t.id); }
    catch (e) { if (kor === this.zarKor['zarTetel']) this.zarEngedd('zarTetel'); throw e; }
  }
  /** A zár felszabadulásakor / a sáv „Újratöltés”-ére: friss adat, ha még ez a bizonylat van nyitva. */
  private async tetelUjratolt(id: string) { if (this.szerk?.id != null && String(this.szerk.id) === id) await this.tetelBetolt(id); }
  private async tetelBetolt(id: string) {
    const teljes: any = await this.get(`/tetel/${id}`);
    await this.tukorBetolt();
    await this.partnerekBetolt();
    //  Végszámla előlegből: a „Előleg beszámítása” sorok a 2. tétel – külön, hogy a 311 / 454X-et ne vegyük főlábnak.
    const beszSorok = (teljes.sorok || []).filter((s: any) => String(s.megjegyzes || '').startsWith(BESZAMITAS_JEL));
    const fl = this.bontFixLab((teljes.sorok || []).filter((s: any) => !beszSorok.includes(s)), teljes.naplo_tipus);
    const d = (v: any) => (v ? String(v).slice(0, 10) : null);
    // A sorok HUF-ban tároltak; devizás bizonylatnál VISSZAVÁLTJUK devizára, mert a szerkesztő
    // devizában dolgozik és mentéskor újra HUF-ra vált (különben duplán szorozna).
    const arf = teljes.deviza && Number(teljes.arfolyam) > 0 ? Number(teljes.arfolyam) : 0;
    const sorok = (fl.sorok.length ? fl.sorok : [this.uresSor()]).map((s: any) =>
      (arf ? { ...s, osszeg: s.osszeg == null ? null : Math.round((Number(s.osszeg) / arf) * 100) / 100 } : s));
    this.szerk = { ...teljes, datum: d(teljes.datum), teljesites: d(teljes.teljesites), afa_datum: d(teljes.afa_datum), hatarido: d(teljes.hatarido),
      devizas: !!teljes.deviza, deviza: teljes.deviza || 'EUR', arfolyam: teljes.arfolyam != null ? Number(teljes.arfolyam) : null,
      foszamla: fl.foszamla, sorok };
    this.kapcsolatBetolt(teljes);
    if (beszSorok.length) {
      this.lepesek = [{ szerep: 'eloleg_beszamitas', naplo_tipus: 'fo', megnevezes: beszSorok[0].megjegyzes,
        sorok: beszSorok.map((x: any) => this.lepesSor(x.szamlaszam, Number(x.tartozik) > 0 ? 'T' : 'K', (Number(x.tartozik) || 0) || (Number(x.kovetel) || 0))) },
        ...this.lepesek];
      this.kapcsolatSzerep = 'vegszamla';
    }
    this.bizEllenoriz();
    this.javaslatok = [];
    await this.forditBetolt(teljes.bizonylatszam);
    await this.ellenszamlaElokeszit();
    this.szamlasorokbol();
    this.urlapFokusz();
    await this.szamlaKapcsolatBetolt();
  }

  /* ══════════ MÓDOSÍTÓ SZÁMLA ÉS AZ EREDETIJE (backend: szamla-modositas.js) ══════════
   *  A módosító az eredetivel EGYÜTT érvényes. 0 Ft-osnál könyvelés nélkül csatoljuk; összeggel a
   *  módosító a saját bizonylatával könyvelődik, és mentéskor az eredetihez kötjük (az eredeti nyitott
   *  tétele a módosítással igazodik). A bizonylatnál mindkét irányban látszik a pár. */
  osaCsatoltSet = new Set<string>();
  modositoPar: any = null;          // a könyvelőablakban nyitott módosító számla (mentéskor kötjük)
  szamlaKapcsolat: any = null;      // a megnyitott bizonylat párja(i)
  private static modositoE(s: any) { return String(s?.muvelet || '').toUpperCase() === 'MODIFY' && !!s?.eredeti_szamlaszam; }
  async szamlaKapcsolatBetolt() {
    this.szamlaKapcsolat = null;
    const sz = this.szerk?.osa_szamlaszam || this.szerk?.bizonylatszam;
    if (!sz || !this.szerk?.id) return;
    try {
      const r: any = await this.get(`/szamla-kapcsolat/${this.aktiv.ugyfelId}?szamlaszam=${encodeURIComponent(sz)}`);
      if (r?.eredeti || r?.modositok?.length) this.szamlaKapcsolat = r;
    } catch { /* nincs kapcsolat */ }
  }
  async kapcsoltNyit(tetelId: string | null) {
    if (!tetelId) return this.hiba('A kapcsolt számla könyvelés nélkül csatolt (0 Ft-os módosító) – nincs saját bizonylata.');
    await this.szerkTetel({ id: tetelId });
  }
  async osaCsatol(s: any) {
    await this.osaModal?.dismiss();
    const a = await this.alert.create({ header: 'Módosító számla csatolása',
      message: `A(z) ${s.szamlaszam} 0 Ft-os módosító számla – könyvelni nem kell, de az eredetivel (${s.eredeti_szamlaszam}) együtt érvényes. Összekössem?`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Csatolás', role: 'ok' }] });
    await a.present();
    if ((await a.onDidDismiss()).role !== 'ok') return;
    try {
      const r: any = await this.post(`/osa-modosito/${this.aktiv.ugyfelId}`, { modosito: s });
      await this.osaKonyveltBetolt();
      this.ok(r?.fuggo ? `${s.szamlaszam} csatolva. ${r.uzenet}` : `${s.szamlaszam} az eredetihez (${s.eredeti_szamlaszam}) csatolva.`);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült csatolni.'); }
  }
  // A bizonylat dátumának állításakor devizásnál újrakérjük az MNB-árfolyamot arra a napra.
  keltValt() { if (this.szerk?.devizas) this.arfolyamFrissit(); }
  datStr(d: Date) { return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; }
  sorHozzaad() { this.szerk.sorok.push(this.uresSor()); }
  sorTorol(i: number) { this.szerk.sorok.splice(i, 1); }

  // a napló FIX lába (fő számla) + a tanult javaslatok betöltése; a fő számla a sorok fölött áll, nem sorban
  async ellenszamlaElokeszit() {
    const j: any = await this.post(`/kontir-javaslat/${this.aktiv.ugyfelId}`, { naplo_tipus: this.szerk.naplo_tipus, partner_nev: this.szerk.partner_nev, partner_id: this.szerk.partner_id || null, megnevezes: this.szerk.megnevezes });
    this.javaslatok = j.javaslatok || [];
    this.bevTanultAtvesz(j.bevsor_tanult);
    if (j.ellenszamla && !this.szerk.foszamla) this.szerk.foszamla = j.ellenszamla;   // fix láb, ha még üres
    this.ugyfelAfas = j.afas !== false;
    this.afaFizSzla = j.afa_fizetendo || this.beallitas?.afa_fizetendo || '467';
    this.afaEloSzla = j.afa_elozetes || this.beallitas?.afa_elozetes || '466';
  }

  /* ════════════ A KÖNYVELŐ ABLAK: SZÁMLASOROK → KONTÍR ════════════
   *
   *  A könyvelőprogramok számla-könyvelése szerint: a számla SOROKBÓL áll (megjegyzés, ÁFA-kulcs,
   *  főkönyvi szám, nettó, ÁFA, bruttó), a kontír (T/K) ezekből ÁLL ELŐ – vevőnél a nettó és az
   *  ÁFA követel oldalon a bevétel- és a fizetendő ÁFA számlán, szállítónál tartozik oldalon a
   *  költség- és a levonható ÁFA számlán; a partner-láb (311/4541) kiegyenlít. Nem áfaalany cégnél
   *  a beszerzés bruttóban megy a költségre (nincs levonható ÁFA).
   *
   *  A Kontírozás fülön a kontír kézzel is módosítható: onnantól a kézi kontír érvényes, a
   *  számlasorok módosítása már nem írja felül (a fülön egy gombbal újraépíthető). */
  ful: 'szamlasor' | 'kontir' | 'kep' = 'szamlasor';
  private osaElokeszitett = false;
  szamlasorok: any[] = [];
  kontirKezi = false;
  ugyfelAfas = true;
  afaFizSzla = '467';
  afaEloSzla = '466';
  get szamlasoros() { return ['vevo', 'szallito'].includes(this.szerk?.naplo_tipus); }
  ujSzamlasor(): any {
    /*  NEM ÁFAALANY CÉGNÉL nincs ÁFÁ-s tétel: a beszerzés BRUTTÓBAN a költségre megy (nincs mit
     *  levonni). Egyetlen kivétel a fordított adózás: ott az adót akkor is önadózni kell – csak
     *  nem levonható, hanem ráfordítás. */
    /*  NEM ÁFAALANYNÁL (alanyi adómentes) a tétel ÁFA nélküli, és bevallási sor sem jár hozzá: az
     *  alanyi mentes cég rendes ÁFA-bevallást nem ad, csak fordított adózásnál vall be fizetendő
     *  adót – azt a fordított ÁFA bizonylata viszi. (Korábban itt a 63. sor volt az alapérték.) */
    return { megj: '', afas: !!this.ugyfelAfas, fordit: false, afa_v: this.ugyfelAfas ? '27' : 'AAM',
      afa_kulcs: this.ugyfelAfas ? 27 : 0, afa_kod: this.ugyfelAfas ? null : 'AAM', bev_sor: '', adokod: '', osszesito: null, fordit_jogcim: null,
      munkaszam: this.szerk?.munkaszam || '', fok: '', oldal: this.alapSorOldal(), afa_szla: '', netto: null, afa: null, brutto: null };
  }

  /**  Jelölhető-e az „ÁFÁ-s tétel"? Nem áfaalany cégnél nem: ott bruttóban könyvelünk. */
  get afasTetelLehet(): boolean { return !!this.ugyfelAfas; }
  /**  Nem áfaalanynál a választék: adókulcs nélkül – csak a mentes kódok és a fordított adózás. */
  get afaValasztekNemAfas() { return KettosComponent.AFA_VALASZTEK.filter((a) => !a.kulcs); }

  /**  A BEVALLÁSI SOR csak akkor kitölthető, ha a sornak van ÁFA-kezelése: áfás tétel vagy
   *   fordított adózás. Enélkül nincs mit bevallani, ezért a mező is zárva marad. */
  bevSorLehet(x: any): boolean { return !!(x && (x.fordit || (x.afas && this.afasTetelLehet))); }

  /*  ADÓKÓD ↔ BEVALLÁSI SOR. Az adókód a 65-ös bevallás sorához köt (a törzs a bevallási sorokból
   *  épül): az egyszeres kód egy fizetendő VAGY levonható sorhoz, a páros (pl. 6629) önadózásnál
   *  mindkettőhöz. A választó ezért az oldal szerint szűr: értékesítésnél (követel oldal) a
   *  fizetendő, beszerzésnél a levonható sorok kódjai látszanak, a páros kódok csak fordított
   *  adózásnál (a jogcím sorai szerint). A tájékoztató sorok kódjai mindig választhatók. A „mind”
   *  jelölővel a teljes törzs elérhető. */
  adokodMind = false;
  private adokodSzuro: { irany: 'fiz' | 'lev'; fordit: string | null } | null = null;
  adokodIllik(a: any): boolean {
    //  Alanyi adómentes (nem áfaalany) ügyfélnek nincs levonási joga: levonható oldalú kód nem jöhet szóba.
    if (!this.ugyfelAfas && a.levonhato_sor) return false;
    if (this.adokodMind || !this.adokodSzuro) return true;
    const { irany, fordit } = this.adokodSzuro;
    const fiz = a.fizetendo_sor || null, lev = a.levonhato_sor || null;
    if (fordit) {
      const j = this.forditJogcim(fordit);
      const fs = Object.values(j.fiz).map(String), ls = Object.values(j.lev).map(String);
      if (fiz && lev) return fs.includes(String(fiz)) && ls.includes(String(lev));
      return irany === 'fiz' ? !!fiz && fs.includes(String(fiz)) : !!lev && ls.includes(String(lev));
    }
    if (fiz && lev) return false;             // önadózású pár: csak fordított adózásnál
    if (!fiz && !lev) return true;            // tájékoztató sor
    return irany === 'fiz' ? !!fiz : !!lev;
  }
  /** Melyik oldalon áll a cél: a fordított ÁFA ablak két oldala, vagy a számlasor (követel = értékesítés). */
  private adokodIranya(obj: any): 'fiz' | 'lev' {
    if (this.forditAblak && obj === this.forditAblak.fizetendo) return 'fiz';
    if (this.forditAblak && obj === this.forditAblak.levonhato) return 'lev';
    return (obj?.oldal || this.alapSorOldal()) === 'K' ? 'fiz' : 'lev';
  }
  private adokodForditJogcim(obj: any): string | null {
    if (this.forditAblak && (obj === this.forditAblak.fizetendo || obj === this.forditAblak.levonhato)) return this.forditAblak.jogcim || 'belfoldi';
    return obj?.fordit ? (obj.fordit_jogcim || 'belfoldi') : null;
  }
  /** Az adókód bevallási sora a cél oldalán (egyszeres kódnál a saját sora). */
  private adokodSora(a: any, irany: 'fiz' | 'lev'): string | null {
    return (irany === 'fiz' ? a?.fizetendo_sor : a?.levonhato_sor) || a?.fizetendo_sor || a?.levonhato_sor || null;
  }
  /*  Fordított irány: a bevallási sor beírásakor/választásakor az azonos számú adókód magától
   *  kitöltődik – de csak ha az adókód üres, vagy azt is mi töltöttük (a kézzel írtat nem írjuk felül). */
  bevSorAdokod(obj: any) {
    if (!obj) return;
    const sor = String(obj.bev_sor || '').trim();
    //  A felhasználó adta meg a bevallási sort → mostantól ez a mérvadó, a kulcs-alapú automatika nem írja felül.
    obj._bevSorKezi = !!sor;
    if (obj.adokod && obj.adokod !== obj._adokodAuto) return;
    const a = sor ? this.adokodSorbol(sor, this.adokodIranya(obj)) : null;
    obj.adokod = a ? a.kod : (obj.adokod === obj._adokodAuto ? '' : obj.adokod);
    obj._adokodAuto = obj.adokod;
  }

  /* ══════════ FORDÍTOTT ADÓZÁS (Áfa tv. 142. §) ══════════
   *
   *  A számlán NINCS ÁFA: az adót a VEVŐ önadózással állapítja meg. Ezért a soron csak jelöljük,
   *  a tényleges adó pedig a bizonylat mentése UTÁN, önálló vegyes bizonylatra kerül – ott dől el
   *  a kulcs, a bevallási sor és az adókód is. Csak SZÁLLÍTÓI számlán van értelme. */
  get forditLehet(): boolean { return this.szerk?.naplo_tipus === 'szallito'; }

  /*  A FORDÍTOTT ADÓZÁS JOGCÍMEI. Nem csak belföldi lehet: ha külföldről szerzünk be, az adót
   *  szintén a beszerző állapítja meg – Közösségen belül a partner KÖZÖSSÉGI ADÓSZÁMÁVAL (és
   *  összesítő nyilatkozattal), harmadik országból pedig anélkül. A bevallási sorok jogcímenként
   *  mások (65-ös nyomtatvány, a bevallás-sor törzs szerint). */
  static readonly FORDIT_JOGCIMEK: { v: string; c: string; eu: boolean; osszesito?: string; fiz: Record<number, string>; lev: Record<number, string> }[] = [
    { v: 'belfoldi', c: 'Belföldi fordított adózás (Áfa tv. 142. §)', eu: false,
      fiz: { 27: '29', 18: '29', 5: '29' }, lev: { 27: '66', 18: '65', 5: '64' } },
    { v: 'eu_termek', c: 'Közösségen belüli termékbeszerzés (19–21. §)', eu: true, osszesito: 'termek',
      fiz: { 27: '14', 18: '13', 5: '12' }, lev: { 27: '69', 18: '69', 5: '69' } },
    { v: 'eu_szolgaltatas', c: 'Közösségi adóalanytól igénybe vett szolgáltatás (37. §)', eu: true, osszesito: 'szolgaltatas',
      fiz: { 27: '18', 18: '19', 5: '19' }, lev: { 27: '67', 18: '67', 5: '67' } },
    { v: 'harmadik_szolgaltatas', c: 'Harmadik országbeli adóalanytól igénybe vett szolgáltatás', eu: false,
      fiz: { 27: '27', 18: '27', 5: '27' }, lev: { 27: '67', 18: '67', 5: '67' } },
    { v: 'import', c: 'Termékimport önadózással', eu: false,
      fiz: { 27: '26', 18: '25', 5: '24' }, lev: { 27: '71', 18: '71', 5: '71' } },
  ];
  forditJogcimek = KettosComponent.FORDIT_JOGCIMEK;
  forditJogcim(v: string | null) { return KettosComponent.FORDIT_JOGCIMEK.find((j) => j.v === v) || KettosComponent.FORDIT_JOGCIMEK[0]; }

  /** A „Fordított ÁFA-s tétel" jelölő: a soron nincs ÁFA, az ÁFA% mezők lezárnak. */
  sorAblakForditValt() {
    const x = this.sorAblak;
    if (!x) return;
    if (x.fordit) {
      x.afas = false; x.afa_v = 'FAD'; x.afa_kod = 'FAD'; x.afa_kulcs = 0; x.afa = 0;
      x.brutto = Number(x.netto) || 0;
      if (!x.fordit_jogcim) x.fordit_jogcim = 'belfoldi';
      if (x.adokod === x._adokodAuto || !x.adokod) { x.adokod = ''; x._adokodAuto = ''; }
      this.sorAblakJogcimValt();
    } else if (x.afa_kod === 'FAD') {
      x.afa_v = '27'; x.afa_kod = null; x.afas = true; x.afa_kulcs = 27; x.fordit_jogcim = null;
      if (x.adokod === x._adokodAuto) { x.adokod = ''; x._adokodAuto = ''; }
      this.adokodAuto(x);
    }
    this.szamlasorSzamol(x, 'netto');
  }

  /** Jogcímváltás: az összesítő nyilatkozat jelölése magától igazodik (Közösségen belülinél kell). */
  sorAblakJogcimValt() {
    const x = this.sorAblak;
    if (!x?.fordit) return;
    const j = this.forditJogcim(x.fordit_jogcim);
    x.osszesito = j.eu ? (j.osszesito || null) : null;
    if (!x.bev_sor || Object.values(j.fiz).includes(String(x.bev_sor))) x.bev_sor = '';
    if (x.adokod === x._adokodAuto) { x.adokod = ''; x._adokodAuto = ''; }
    this.adokodAuto(x);
  }

  /** Közösségen belüli ügyletnél a partner KÖZÖSSÉGI adószáma kell (összesítő nyilatkozat). */
  get forditEuHiany(): boolean {
    const x = this.sorAblak;
    if (!x?.fordit || !this.forditJogcim(x.fordit_jogcim).eu) return false;
    const adosz = String(this.szerk?.partner_kozossegi_adoszam || this.szerk?.partner_adoszam || '').trim();
    return !/^[A-Z]{2}\s*\d/i.test(adosz);
  }

  /* ── Adókód: a NAV SZABVÁNYOS ADÓKÓD-KATALÓGUSA (eÁFA; közös, /api/nav-adokod) ──
   *  A kód elemei a bevallás sorai: MP = fizetendő fősor, MD = levonható fősor (DP/DD/DH a
   *  részletező sorok, PG a melléklap). Egyszer töltjük be, a választó ebből szűr. */
  adokodok: any[] = [];
  async adokodokBetolt() {
    if (this.adokodok.length) return;
    try {
      const l: any[] = await this.naplo.getAbs('/api/nav-adokod');
      this.adokodok = (l || []).map((a: any) => ({ ...a, nev: a.leiras, fizetendo_sor: a.mp1 || null, levonhato_sor: a.md || null,
        _elemek: String(a.kod).trim().split(/\s+/).length }));
    } catch { this.adokodok = []; }
  }
  private adokodKeres(kod: string) { const k = String(kod || '').replace(/\s+/g, ' ').trim().toUpperCase(); return this.adokodok.find((x) => x.kod === k); }
  adokodNev(kod: string) { const a = this.adokodKeres(kod); return a ? `${a.beszedes ? a.beszedes + ' – ' : ''}${a.nev || ''}` : (kod ? 'nincs a NAV katalógusában' : ''); }
  /** Az egy sorra mutató „tiszta" kód (MP07 / MD66) – ha a soron csak a bevallási sor van meg. */
  private adokodSorbol(sor: any, irany: 'fiz' | 'lev') {
    const n = String(sor || '').replace(/\D/g, '');
    if (!n) return null;
    return this.adokodKeres(`${irany === 'fiz' ? 'MP' : 'MD'}${n.padStart(2, '0')}`) || null;
  }

  /*  ADÓKÓD-VÁLASZTÓ – ugyanúgy, mint a főkönyvi számnál: lista kereséssel, a törzsből.
   *  (A törzs karbantartása: Törzsadatok → Adókódok.) */
  adokodCel: { obj: any; mezo: string } | null = null;
  adokodKereso = '';
  get adokodLathato(): any[] {
    const k = this.adokodKereso.trim().toLowerCase();
    const lista = this.adokodok.filter((a) => this.adokodIllik(a));
    if (!k) return lista;
    const kt = k.replace(/\s+/g, '');
    return lista.filter((a) => String(a.kod).toLowerCase().replace(/\s+/g, '').includes(kt)
      || String(a.beszedes || '').toLowerCase().replace(/\s+/g, '').includes(kt) || String(a.nev || '').toLowerCase().includes(k));
  }
  async adokodNyit(obj: any, mezo = 'adokod') {
    await this.adokodokBetolt();
    this.adokodKereso = '';
    this.adokodMind = false;
    this.adokodSzuro = { irany: this.adokodIranya(obj), fordit: this.adokodForditJogcim(obj) };
    this.adokodCel = { obj, mezo };
  }
  /*  Választáskor a bevallási sor is kitöltődik a kód szerint. A fordított ÁFA ablakban a kétoldalú
   *  kód (pl. MP29 MD66) MINDKÉT oldalt kitölti: fizetendő 29, levonható 66. A fordított jelölésű
   *  számlasoron a sor nem változik – ott a fordított ÁFA bizonylata viszi a sorokat. */
  adokodValaszt(a: any) {
    const cel = this.adokodCel;
    this.adokodCel = null;
    if (!cel) return;
    this.adokodAlkalmaz(cel.obj, cel.mezo, a);
  }
  /*  Beírt (vagy a legördülőből választott) adókód: ha a katalógusban van, ugyanúgy viszi a
   *  bevallási sort és a kulcsot, mint a választóból választott – nem kell kézzel utánaírni. */
  adokodBeirva(obj: any, mezo = 'adokod') {
    if (!obj) return;
    const nyers = String(obj[mezo] || '').trim();
    //  Ha az ADÓKÓD mezőbe PUSZTA SZÁMOT írnak (pl. „68"), az a BEVALLÁSI SOR, nem adókód – az
    //  adókód a NAV-katalógus kódja (MD68/MP29). Ezért a számot a Bev. sorba tesszük, és onnan
    //  derítjük az adókódot. Enélkül a bare szám nem katalógus-kód → mentésre „visszaugrott".
    if (mezo === 'adokod' && /^\d{1,3}$/.test(nyers) && !this.adokodKeres(nyers)) {
      obj.bev_sor = nyers; obj.adokod = ''; obj._adokodAuto = '';
      this.bevSorAdokod(obj);
      return;
    }
    const a = this.adokodKeres(obj[mezo]);
    if (!a) { if (!obj[mezo]) obj._adokodAuto = null; return; }
    this.adokodAlkalmaz(obj, mezo, a);
  }
  private adokodAlkalmaz(obj: any, mezo: string, a: any) {
    if (!this.ugyfelAfas && a.levonhato_sor) {
      this.hiba(`Az ügyfél alanyi adómentes (nem áfaalany), levonási joga nincs – a(z) ${a.kod} levonható oldalú kód nem választható. Fordított adózásnál csak a fizetendő oldal jár (pl. MP29), az adó ráfordítás.`);
      return;
    }
    obj[mezo] = a.kod; obj._adokodAuto = null;
    const f = this.forditAblak;
    if (f && (obj === f.fizetendo || obj === f.levonhato)) {
      if (a.fizetendo_sor && a.levonhato_sor) {
        f.fizetendo.adokod = a.kod; f.levonhato.adokod = a.kod;
        f.fizetendo.bev_sor = a.fizetendo_sor; f.levonhato.bev_sor = a.levonhato_sor;
      } else {
        const sor = this.adokodSora(a, obj === f.fizetendo ? 'fiz' : 'lev');
        if (sor) obj.bev_sor = sor;
      }
      this.forditElonezetFrissit();
      return;
    }
    if (!obj.fordit && 'bev_sor' in obj) {
      const sor = this.adokodSora(a, this.adokodIranya(obj));
      if (sor) { obj.bev_sor = sor; this.bevsorNevekBetolt(); }
      this.adokodbolKulcs(obj, a);
      if (a.kod === 'KL V00' && this.levonhatoLehet(obj)) obj.levonhato = 0;
    }
  }
  /* ── Tételes fordított adózású tételek (a bevallás melléklete) ── */
  forditTetelAblak: any = null;
  forditTermekek: { vtsz: string; nev: string }[] = [];
  private forditTermekekEv: number | null = null;
  forditTetelek: any[] = [];
  async forditTermekekBetolt() {
    if (this.forditTermekek.length && this.forditTermekekEv === this.aktiv.ev) return;
    try { this.forditTermekek = await this.get(`/forditott-termekek?ev=${this.aktiv.ev}`); } catch { this.forditTermekek = []; }
    this.forditTermekekEv = this.aktiv.ev;
  }
  /** A 6/A–6/C. mellékletes (gabona, acél, gáz) tételes fordított adózás 2027-01-01-jével megszűnik
   *  (Áfa tv. 142. § (1) i)–k)) – a gomb csak a 2026-ig teljesített ügyletnél jelenik meg. */
  get tetelesForditottElerheto(): boolean {
    const ev = Number(String(this.szerk?.teljesites || this.szerk?.datum || '').slice(0, 4)) || Number(this.aktiv.ev);
    return ev <= 2026;
  }
  /** „Tételes ford. ÁFA + Mentés": a számlasor mentése, majd a tételes nyilatkozat rögzítése. */
  async forditTetelNyit(mentsemASort = true) {
    await this.forditTermekekBetolt();
    if (mentsemASort) this.sorAblakMent();
    const ma = new Date().toISOString().slice(0, 10);
    this.forditTetelAblak = {
      irany: this.szerk?.naplo_tipus === 'vevo' ? 'ertekesites' : 'beszerzes',
      bevallas_datum: this.szerk?.afa_datum || this.szerk?.teljesites || this.szerk?.datum || ma,
      teljesites: this.szerk?.teljesites || this.szerk?.datum || ma,
      bizonylatszam: this.szerk?.bizonylatszam || '',
      partner_id: this.szerk?.partner_id || null, partner_nev: this.szerk?.partner_nev || '',
      adoszam: this.szerk?.partner_adoszam || '',
      vtsz: '', termek_nev: '', mennyiseg: null, mennyiseg_nelkul: false,
      adoalap: this.forditAlapOsszeg || null,
    };
  }
  //  A 07/08-as melléklap mértékegysége: kg (6/A, 6/B), a gáznál MWh (6/C) – a NAV eÁFA-sémája szerint.
  get forditTermekMe(): string { return (this.forditTermekek as any[]).find((x) => x.vtsz === this.forditTetelAblak?.vtsz)?.me || 'kg'; }
  forditTermekValt() {
    const t = this.forditTermekek.find((x) => x.vtsz === this.forditTetelAblak?.vtsz);
    if (t && this.forditTetelAblak) this.forditTetelAblak.termek_nev = `${t.vtsz} - ${t.nev}`;
  }
  async forditTetelMent() {
    const x = this.forditTetelAblak;
    if (!x) return;
    if (!x.vtsz) return this.hiba('Válassz terméket (vámtarifaszám).');
    if (!(Number(x.adoalap) > 0)) return this.hiba('Az adóalap kötelező.');
    try {
      await this.post(`/forditott-tetel/${this.aktiv.ugyfelId}?ev=${this.aktiv.ev}`, { ...x, tetel_id: this.szerk?.id || null });
      this.forditTetelAblak = null;
      this.ok('Tételes fordított adózású tétel rögzítve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni a tételt.'); }
  }

  /** A fordított adózású számlasorok nettó összege (ebből számol a fordított ÁFA ablaka). */
  get forditAlapOsszeg(): number {
    return Math.round(this.szamlasorok.filter((x: any) => x.fordit).reduce((a: number, x: any) => a + (Number(x.netto) || 0), 0) * 100) / 100;
  }

  /*  ÁFA %: a sima kulcsok, és ha nem kulcs szerint adózik, a NAV Online Számla kódjai (a kulcs 0,
   *  ÁFA-sor nem keletkezik). A fordított adózás (FAD) önálló ÁFA-bizonylata a kontír ablakban. */
  static readonly AFA_VALASZTEK: { v: string; c: string; kulcs: number; kod: string | null }[] = [
    { v: '27', c: '27%', kulcs: 27, kod: null }, { v: '18', c: '18%', kulcs: 18, kod: null },
    { v: '5', c: '5%', kulcs: 5, kod: null }, { v: '0', c: '0%', kulcs: 0, kod: null },
    { v: 'AAM', c: 'AAM – alanyi adómentes', kulcs: 0, kod: 'AAM' },
    { v: 'TAM', c: 'TAM – tárgyi adómentes', kulcs: 0, kod: 'TAM' },
    { v: 'KBAET', c: 'KBAET – Közösségen belüli adómentes', kulcs: 0, kod: 'KBAET' },
    { v: 'EAM', c: 'EAM – export, adómentes', kulcs: 0, kod: 'EAM' },
    { v: 'ATK', c: 'ATK – ÁFA tárgyi hatályán kívül', kulcs: 0, kod: 'ATK' },
    { v: 'FAD', c: 'FAD – belföldi fordított adózás', kulcs: 0, kod: 'FAD' },
  ];
  afaValasztek = KettosComponent.AFA_VALASZTEK;
  /** Az ÁFA-választó értéke → kulcs és kód; a nem ÁFÁ-s tételnél 0, ÁFA nélkül. */
  afaValt(x: any, kodIs = true) {
    const v = KettosComponent.AFA_VALASZTEK.find((a) => a.v === x.afa_v) || KettosComponent.AFA_VALASZTEK[0];
    x.afa_kulcs = x.afas === false ? 0 : v.kulcs;
    x.afa_kod = x.afas === false ? null : v.kod;
    if (kodIs) this.adokodAuto(x);
    this.szamlasorSzamol(x, 'netto');
  }

  /* ── Bevallási sor kiválasztása a törzsből (bevsor-valaszto) ── */
  bevsorCel: { obj: any; mezo: string } | null = null;
  bevsorNevek = new Map<string, string>();
  bevsorNyit(obj: any, mezo: string) { this.bevsorCel = { obj, mezo }; }
  bevsorValaszt(s: { kod: string; nev: string }) {
    if (this.bevsorCel) { this.bevsorCel.obj[this.bevsorCel.mezo] = s.kod; if (this.bevsorCel.mezo === 'bev_sor') this.bevSorAdokod(this.bevsorCel.obj); }
    this.bevsorNevek.set(s.kod, s.nev);
    this.bevsorCel = null;
  }
  async bevsorNevekBetolt() {
    try {
      const l: any[] = await firstValueFrom(this.http.get<any[]>('/api/naplo-naplok/bevallas-sorok?mind=1'));
      this.bevsorNevek = new Map(l.map((x) => [x.kod, x.nev]));
    } catch { /* a kód is elég */ }
  }
  bevsorNev(kod: string | null | undefined): string { return kod ? this.bevsorNevek.get(kod) || '' : ''; }
  async bevallasSorokBetolt() { await this.bevsorNevekBetolt(); await this.adokodokBetolt(); }
  get bevallasSorok(): string[] { return [...this.bevsorNevek.keys()]; }

  /* ══════════ eÁFA: A SZÁMLASOR NAV-ADÓKÓDJA ══════════
   *
   *  Az eÁFA-ban a tételes áfaanalitika minden sora a NAV szabványos adókódját viszi – ebből dönti
   *  el a NAV a bevallási sort és ellenőrzi az adó és az alap arányát. Ezért a soron az adókód az
   *  ÁFA fő adata: az ÁFA-választóból és az oldalból (értékesítés = követel, beszerzés = tartozik)
   *  MAGÁTÓL kitöltődik, a választott kód pedig viszi a bevallási sort és – ahol meghatározza –
   *  a kulcsot is. A kézzel választott kódot nem írjuk felül. */
  static readonly ADOKOD_ALAP: Record<'fiz' | 'lev', Record<string, string>> = {
    fiz: { '27': 'MP07', '18': 'MP06', '5': 'MP05', '0': 'MP110', TAM: 'MP08', KBAET: 'MP02', EAM: 'MP01', FAD: 'MP04', AAM: 'KF V00', ATK: 'KF V00' },
    lev: { '27': 'MD66', '18': 'MD65', '5': 'MD64', '0': 'MD111', TAM: 'MD63', AAM: 'MD63', ATK: 'KL V00' },
  };
  //  A bevallási sor adókulcsa (a kód fősorából): a NAV ehhez méri az adót.
  static readonly SOR_KULCS: Record<string, number> = {
    '05': 5, '06': 18, '07': 27, '110': 0, '12': 5, '13': 18, '14': 27, '15': 27, '16': 27, '24': 5, '25': 18, '26': 27, '28': 27,
    '64': 5, '65': 18, '66': 27, '111': 0,
  };
  /** ÁFA nélküli, de bevallási jelentőségű jelölések – az ÁFA nélküli soron is megőrizzük őket. */
  static readonly MENTES_KODOK = ['AAM', 'TAM', 'KBAET', 'EAM', 'ATK'];
  static readonly KOD_AFA_V: Record<string, string> = { MP08: 'TAM', MP02: 'KBAET', MP01: 'EAM', MD63: 'AAM', 'KF V00': 'ATK', 'KL V00': 'ATK' };
  /** Az oldalhoz és az ÁFA-választáshoz illő alapkód (null: nincs ÁFA-kezelés). */
  adokodAlap(x: any): string | null {
    if (!x) return null;
    const irany = this.adokodIranya(x);
    if (x.fordit) {
      const j = this.forditJogcim(x.fordit_jogcim);
      const fiz = String(j.fiz[27]), lev = this.ugyfelAfas ? String(j.lev[27]) : null;
      const jeloltek = this.adokodok.filter((a: any) => String(a.fizetendo_sor || '') === fiz && String(a.levonhato_sor || '') === String(lev || ''));
      //  Tárgyi eszköz fordított adós beszerzése (pl. import „MP26 MD71 DD77"): a részletező kódos változat.
      const dd = lev ? this.eszkozReszletezo(x) : null;
      const eszkozos = dd ? jeloltek.filter((a: any) => String(a.kod).split(' ').includes(dd)) : [];
      const jelolt = (eszkozos.length ? eszkozos : jeloltek.filter((a: any) => !/\bDD7[789]\b/.test(a.kod)))
        .sort((a: any, b: any) => a._elemek - b._elemek)[0];
      return jelolt ? jelolt.kod : null;
    }
    if (!x.afas || !this.afasTetelLehet) return null;
    if (irany === 'lev' && x.levonhato !== '' && x.levonhato != null && Number(x.levonhato) === 0) return 'KL V00';
    const alap = KettosComponent.ADOKOD_ALAP[irany][String(x.afa_v || '')] || null;
    //  Tárgyi eszköz / beruházás levonható ÁFÁ-ja: a katalógus részletező kódja (DD77, DD79), ha a
    //  fősorhoz létezik ilyen kód (pl. „MD65 DD77" nincs – ott a fősor marad).
    const dd = alap && irany === 'lev' ? this.eszkozReszletezo(x) : null;
    if (dd && this.adokodKeres(`${alap} ${dd}`)) return `${alap} ${dd}`;
    return alap;
  }
  /*  A beszerzés főkönyvi számából a részletező kód (NAV adókód-katalógus, Áfa tv. 259. § 25.):
   *   11–14 (immateriális jószág, ingatlan, gép, jármű)   → DD77 tárgyi eszköz beszerzése
   *   16 (beruházás – még nem aktivált saját beruházás)    → DD79
   *  Az apport (DD78) nem a főkönyvi számból következik – azt a könyvelő választja ki. Csak az ÁFA
   *  levonására jogosult ügyfélnél van értelme: az alanyi mentesnél a beszerzés ÁFÁ-ja a bekerülési
   *  érték része (Szt. 47. § (2)), levonható oldala nincs. */
  eszkozReszletezo(x: any): string | null {
    if (!this.ugyfelAfas) return null;
    const fok = String(x?.fok ?? x?.szamlaszam ?? '').trim();
    if (/^1[1-4]/.test(fok)) return 'DD77';
    if (/^16/.test(fok)) return 'DD79';
    return null;
  }
  /** Kitölti az adókódot (és a bevallási sort), ha üres vagy a gép töltötte. */
  adokodAuto(x: any) {
    if (!x) return;
    //  KÉZZEL megadott (vagy tárolt) BEVALLÁSI SORT nem írunk felül a kulcs-alapú auto-kóddal: különben a
    //  27%-hoz rendelt alapsor (pl. 66) visszanyomná a felhasználó által beállított sort (pl. 68). A könyvelő
    //  szándékkal tehet egy 27%-os tételt a 68-as sorra (pl. az ÁFA-arányosításhoz).
    if (x._bevSorKezi && x.bev_sor && !x.fordit) return;
    if (x.adokod && x.adokod !== x._adokodAuto) return;
    const alapKod = this.adokodAlap(x);
    //  A partnernél TANULT bevallási sor elsőbbséget kap a beégetett kulcs→sor alapértékkel szemben.
    const t = this.bevTanultKod(x, alapKod);
    const kod = t ? t.kod : alapKod;
    x.adokod = kod || ''; x._adokodAuto = x.adokod;
    x._bevTanult = t ? t.tanult : null;
    if (kod && !x.fordit) {
      const a = this.adokodKeres(kod);
      const sor = a && this.adokodSora(a, this.adokodIranya(x));
      if (sor) { x.bev_sor = sor; x._bevSorKezi = false; this.bevsorNevekBetolt(); }
    }
  }

  /* ══════════ TANULT BEVALLÁSI SOR (backend/naplo-bevsor-tanulas.js) ══════════
   *
   *  Ha a könyvelő egy tételnél a bevallási sort a beégetett alapértéktől (27% → 07 / 66 …)
   *  eltérőre állítja és elmenti, a rendszer megjegyzi partner + ÁFA-kulcs + oldal szerint, és
   *  legközelebb ugyanannál a partnernél, ugyanazzal a kulccsal és oldallal azt ajánlja. A kulcs a
   *  kulcs része, így a kevert kulcsú partnernél is pontos. A tanult értéket a kontír-javaslat hozza
   *  (bevsor_tanult); a sor a „tanult” jelölést kapja, és kézzel átírható. */
  private bevTanult = new Map<string, { sor: string; gyakorisag: number; partner: string }>();
  /*  A partner tanult sorainak átvétele. Csak a térképet cseréli: a kontír-javaslat a bizonylat
   *  betöltésekor még az ELŐZŐ bizonylat számlasorai mellett érkezik – azokhoz nem nyúlhatunk. */
  bevTanultAtvesz(l: any[] | null | undefined) {
    this.bevTanult = new Map((l || []).map((x: any): [string, { sor: string; gyakorisag: number; partner: string }] => [`${x.oldal}|${x.afa_kulcs}`,
      { sor: String(x.bevallas_sor || ''), gyakorisag: Number(x.gyakorisag) || 0, partner: String(x.partner_nev || this.szerk?.partner_nev || '') }]));
  }
  /*  A gép töltötte (nem kézi) számlasorok igazítása a tanult sorokhoz – partnerváltáskor és a
   *  NAV-számla behúzásakor. Csak azt a sort bántjuk, amelyre tanult érték vonatkozik, vagy amelyen
   *  eddig tanult érték állt (más partnernél visszaáll az alapra); a többi sor marad, ahogy volt. */
  bevTanultIgazit() {
    let valt = false;
    const igazit = (x: any) => {
      if (!x || x.fordit || !x.afas || x._bevSorKezi || (x.adokod && x.adokod !== x._adokodAuto)) return false;
      if (!x._bevTanult && !this.bevTanultKod(x, this.adokodAlap(x))) return false;
      const elotte = x.bev_sor;
      this.adokodAuto(x);
      return x.bev_sor !== elotte;
    };
    for (const x of this.szamlasorok || []) if (igazit(x)) valt = true;
    if (this.sorAblak) igazit(this.sorAblak);
    if (valt && !this.kontirKezi) this.kontirEpit();
  }
  /*  A tanult sorhoz illő NAV-adókód (MD68, MP02 …), ha a tanult sor eltér az alapkód sorától. A
   *  tárgyi eszköz részletező kódja (DD77/DD79) megmarad, ha a katalógusban van ilyen kombináció.
   *  Ha a tanult sorhoz nincs katalógus-kód, az alap marad (adókód nélkül az eÁFA nem fogadná). */
  private bevTanultKod(x: any, alapKod: string | null): { kod: string; tanult: any } | null {
    if (!x || x.fordit || !alapKod || alapKod === 'KL V00' || !this.bevTanult.size) return null;
    const irany = this.adokodIranya(x);
    const t = this.bevTanult.get(`${irany}|${String(x.afa_v ?? '')}`);
    if (!t?.sor) return null;
    const alapA = this.adokodKeres(alapKod);
    const alapSor = (alapA && this.adokodSora(alapA, irany)) || '';
    const n = (v: any) => String(v || '').replace(/^0+(?=\d)/, '');
    if (n(t.sor) === n(alapSor)) return null;
    const a = this.adokodSorbol(t.sor, irany);
    if (!a) return null;
    const dd = String(alapKod).split(' ').slice(1).join(' ');
    const kod = dd && this.adokodKeres(`${a.kod} ${dd}`) ? `${a.kod} ${dd}` : a.kod;
    return { kod, tanult: { ...t, alap: alapSor } };
  }
  /** A „tanult” jelölés: a sor most is a tanult értéken áll (kézi átírás után eltűnik). */
  bevTanultLatszik(x: any): boolean { return !!(x?._bevTanult && x.bev_sor && x.bev_sor === x._bevTanult.sor); }
  bevTanultCim(x: any): string {
    const t = x?._bevTanult;
    if (!t) return '';
    const kulcs = /^\d+$/.test(String(x.afa_v || '')) ? `${x.afa_v}%` : String(x.afa_v || '');
    return `Tanult érték: ${t.partner || 'ennél a partnernél'} ${kulcs}-os ${this.adokodIranya(x) === 'fiz' ? 'fizetendő' : 'levonható'} tételeit `
      + `${t.gyakorisag}× a(z) ${t.sor}. sorra könyvelted (a kulcs szerinti alap a(z) ${t.alap || '–'}. sor lenne). Átírható.`;
  }
  /** A kódból következő kulcs / ÁFA-választás (pl. MD65 → 18%, MP08 → TAM). */
  private adokodbolKulcs(x: any, a: any) {
    if (!x || !a || x.fordit || !x.afas) return;
    const kulcs = KettosComponent.SOR_KULCS[String(a.fizetendo_sor || '')] ?? KettosComponent.SOR_KULCS[String(a.levonhato_sor || '')];
    const v = KettosComponent.KOD_AFA_V[a.kod] || (kulcs != null ? String(kulcs) : null);
    if (v && v !== String(x.afa_v)) { x.afa_v = v; this.afaValt(x, false); }
  }
  /*  LEVONHATÓ HÁNYAD (Áfa tv. 123–124. §): pl. a telefon ÁFA-jának 30%-a nem vonható le. Csak
   *  áfás BESZERZÉSNÉL van értelme; a le nem vonható rész a költség része, az eÁFA-ban pedig
   *  deductionRate / deductionAmount. 0% → a kód KL V00 (le nem vonható adó). */
  levonhatoLehet(x: any): boolean {
    return !!(x && !x.fordit && x.afas && this.afasTetelLehet && this.adokodIranya(x) === 'lev' && Number(x.afa_kulcs) > 0);
  }
  levonhatoValt(x: any) {
    if (x.levonhato !== '' && x.levonhato != null) x.levonhato = Math.max(0, Math.min(100, Number(x.levonhato) || 0));
    if (x.adokod === 'KL V00' && Number(x.levonhato) !== 0) { x.adokod = ''; x._adokodAuto = ''; }
    this.adokodAuto(x);
  }
  /*  Mentés előtt: minden ÁFA-kezelésű sornak legyen érvényes NAV-adókódja (az eÁFA enélkül nem
   *  fogadja be az analitikát). Ami üres, azt az alapkód tölti; ami így sem megy, azt jelezzük. */
  private adokodEllenoriz(): string | null {
    if (!this.szamlasoros) return null;
    let i = 0;
    for (const x of this.kitoltottSzamlasorok) {
      i++;
      if (!(x.fordit || (x.afas && this.afasTetelLehet))) continue;
      if (!x.adokod) this.adokodAuto(x);
      if (!x.adokod) return `A(z) ${i}. számlasorhoz NAV-adókód kell (eÁFA) – válaszd ki a számlasor ablakában.`;
      if (this.adokodok.length && !this.adokodKeres(x.adokod)) return `A(z) ${i}. számlasor adókódja („${x.adokod}") nincs a NAV katalógusában.`;
      if (!this.ugyfelAfas && /\bMD\d+/.test(String(x.adokod))) return `A(z) ${i}. számlasor adókódja („${x.adokod}") levonható ÁFÁ-t jelöl, de az ügyfél alanyi adómentes – levonási joga nincs. Válassz levonható oldal nélküli kódot (fordított adózásnál pl. MP29).`;
    }
    return null;
  }

  /* ── „Számlasor rögzítése" ablak (RLB) ── */
  sorAblak: any = null;          // a szerkesztett számlasor másolata
  private sorAblakIndex = -1;    // -1 = új sor
  afaAlapSzla(): string { return this.szerk?.naplo_tipus === 'vevo' ? this.afaFizSzla : this.afaEloSzla; }
  sorAblakNyit(i: number | null) {
    const x = i != null && i >= 0 ? this.szamlasorok[i] : null;
    this.sorAblakIndex = x && !this.szamlasorUres(x) ? (i as number) : -1;
    this.sorAblak = x && !this.szamlasorUres(x) ? { ...x } : this.ujSzamlasor();
    if (!this.sorAblak.afa_v) this.sorAblak.afa_v = this.sorAblak.afa_kod || String(this.sorAblak.afa_kulcs ?? 27);
    if (this.sorAblak.afas === undefined) this.sorAblak.afas = !!(Number(this.sorAblak.afa) || Number(this.sorAblak.afa_kulcs));
    if (!this.bevallasSorok.length) this.bevallasSorokBetolt();
    const ablak = this.sorAblak;
    this.adokodokBetolt().then(() => this.adokodAuto(ablak));
  }
  sorAblakAfasValt() {
    const x = this.sorAblak;
    if (!x.afas) {
      //  Nem áfaalanynál (alanyi mentes) az ÁFA nélküli tétel AAM, nem 0%.
      if (this.ugyfelAfas) { x.afa_v = '0'; x.afa_kod = null; } else { x.afa_v = 'AAM'; x.afa_kod = 'AAM'; }
      x.afa_kulcs = 0;
    }
    else if (x.afa_v === '0') { x.afa_v = '27'; }
    this.afaValt(x);
  }
  sorAblakOsszesito(fajta: 'termek' | 'szolgaltatas', be: boolean) { this.sorAblak.osszesito = be ? fajta : null; }
  sorAblakMent() {
    const x = this.sorAblak;
    if (!Number(x.netto) && !Number(x.brutto)) { this.hiba('Adj meg nettó vagy bruttó összeget.'); return; }
    if (this.sorAblakIndex >= 0) this.szamlasorok[this.sorAblakIndex] = x;
    else this.szamlasorok.splice(Math.max(0, this.szamlasorok.length - 1), 0, x);   // az utolsó (üres) sor elé
    this.sorAblak = null;
    this.szamlasorValt();
  }
  oldalValt(x: any) { x.oldal = x.oldal === 'T' ? 'K' : 'T'; this.adokodAuto(x); }
  private szamlasorUres(x: any) { return !x.fok && !Number(x.netto) && !Number(x.brutto) && !x.megj; }
  szamlasorokIgazit() {
    const l = this.szamlasorok;
    while (l.length > 1 && this.szamlasorUres(l[l.length - 1]) && this.szamlasorUres(l[l.length - 2])) l.pop();
    if (!l.length || !this.szamlasorUres(l[l.length - 1])) l.push(this.ujSzamlasor());
  }
  get kitoltottSzamlasorok() { return this.szamlasorok.filter((x) => !this.szamlasorUres(x)); }
  /** Egy számlasor ÁFA-ja és bruttója (vagy nettója a bruttóból). Forintnál egész, devizánál két tizedes. */
  szamlasorSzamol(x: any, forras: 'netto' | 'brutto') {
    const tized = this.szerk?.devizas ? 100 : 1;
    const k = x.afas === false ? 0 : (Number(x.afa_kulcs) || 0);
    if (forras === 'brutto' && Number(x.brutto)) {
      x.netto = Math.round((Number(x.brutto) / (1 + k / 100)) * tized) / tized;
      x.afa = Math.round((Number(x.brutto) - x.netto) * tized) / tized;
    } else if (Number(x.netto)) {
      x.afa = Math.round(Number(x.netto) * k / 100 * tized) / tized;
      x.brutto = Math.round((Number(x.netto) + x.afa) * tized) / tized;
    }
    this.szamlasorValt();
  }
  szamlasorValt() {
    this.szamlasorokIgazit();
    //  A főkönyvi szám a részletező kódot is eldönti (tárgyi eszköz → DD77) – a gép töltötte kódot igazítjuk.
    for (const x of this.szamlasorok) if (x.fordit || x.afas) this.adokodAuto(x);
    if (!this.kontirKezi) this.kontirEpit();
  }
  szamlasorTorol(i: number) { this.szamlasorok.splice(i, 1); this.szamlasorValt(); }
  szamlasorOsszeg(m: 'netto' | 'afa' | 'brutto') { return Math.round(this.kitoltottSzamlasorok.reduce((a, x) => a + (Number(x[m]) || 0), 0) * 100) / 100; }

  /** A számlasorokból a kontír (a főláb nélküli T/K sorok – a főlábat a szerkesztő egyenlíti ki). */
  kontirEpit() {
    if (!this.szerk || !this.szamlasoros) return;
    const vevo = this.szerk.naplo_tipus === 'vevo';
    const oldal = vevo ? 'K' : 'T';
    const sorok: any[] = [];
    // Az ÁFA-sorok ÁFA-számlánként, kulcsonként és bevallási soronként összevonva.
    const afaCsop = new Map<string, { szla: string; k: number; bev: string | null; adokod: string | null; afa: number; oldal: string }>();
    /*  KEREKÍTÉS: a könyvelés forintban EGÉSZ számokkal megy, fillér nincs (user, 2026-10-07). Devizás
     *  bizonylatnál a soron a deviza-összeg áll (az centes marad) – a forintra váltás kerekít (epitSorok). */
    const kerek = (v: number) => (this.szerk.devizas ? Math.round(v * 100) / 100 : Math.round(v));
    let pontosOssz = 0;
    const koltsegSorok: any[] = [];
    for (const x of this.kitoltottSzamlasorok) {
      const netto = Number(x.netto) || 0, afa = x.afas === false ? 0 : (Number(x.afa) || 0), k = x.afas === false ? 0 : (Number(x.afa_kulcs) || 0);
      //  Levonható hányad: csak a levonható rész megy az előzetesen felszámított ÁFA-ra, a többi a
      //  költség része (Áfa tv. 124. §). Nem áfaalanynál az egész ÁFA költség.
      const arany = this.levonhatoLehet(x) && x.levonhato !== '' && x.levonhato != null ? Math.max(0, Math.min(1, Number(x.levonhato) / 100)) : 1;
      const levAfa = Math.round(afa * arany * 100) / 100;
      const koltseg = !vevo && !this.ugyfelAfas ? netto + afa : netto + (afa - levAfa);
      const sorOldal = x.oldal || oldal;
      pontosOssz += koltseg + ((levAfa && (vevo || this.ugyfelAfas)) ? levAfa : 0);
      if (koltseg) koltsegSorok.push(sorok[sorok.push({ szamlaszam: x.fok || '', megnevezes: x.megj || '', osszeg: kerek(koltseg), afa_kulcs: k || null, oldal: sorOldal,
        //  Fordított adózásnál a soron nincs ÁFA, de a jelölés (FAD), a bevallási sor és az
        //  adókód a könyvelt soron marad – ebből áll össze az ÁFA-analitika.
        //  A mentes jelölés (AAM, TAM, …) ÁFA nélküli sornál is megmarad – enélkül visszanyitáskor 0% lett belőle.
        afa_kod: x.fordit ? 'FAD' : (x.afas === false ? (KettosComponent.MENTES_KODOK.includes(x.afa_kod) ? x.afa_kod : (this.ugyfelAfas ? null : 'AAM')) : (x.afa_kod || null)),
        bevallas_sor: x.bev_sor || null, adokod: x.adokod || null, osszesito: x.osszesito || null,
        fordit_jogcim: x.fordit ? (x.fordit_jogcim || 'belfoldi') : null, munkaszam: x.munkaszam || null,
        levonhato_arany: arany < 1 ? arany : null }) - 1]);
      if (levAfa && (vevo || this.ugyfelAfas)) {
        const szla = x.afa_szla || (vevo ? this.afaFizSzla : this.afaEloSzla);
        const kulcs = `${szla}|${k}|${x.bev_sor || ''}|${x.adokod || ''}|${sorOldal}`;
        const g = afaCsop.get(kulcs) || { szla, k, bev: x.bev_sor || null, adokod: x.adokod || null, afa: 0, oldal: sorOldal };
        g.afa += levAfa; afaCsop.set(kulcs, g);
      }
    }
    for (const g of afaCsop.values()) {
      sorok.push({ szamlaszam: g.szla, megnevezes: `${vevo ? 'Fizetendő' : 'Levonható'} ÁFA ${g.k}%`, osszeg: kerek(g.afa), afa_kulcs: g.k, oldal: g.oldal,
        afa_kod: null, bevallas_sor: g.bev, adokod: g.adokod || null, osszesito: null });
    }
    //  A kerekítési különbözet (soronként kerekítve a végösszeg 1–2 Ft-tal eltérhet a számla kerekített
    //  bruttójától) a legnagyobb költség/bevétel soron rendeződik – így a partner-oldal a számláé.
    if (!this.szerk.devizas && sorok.length) {
      const elteres = Math.round(pontosOssz) - sorok.reduce((a, x) => a + (Number(x.osszeg) || 0), 0);
      const legnagyobb = koltsegSorok.reduce((m: any, x: any) => (!m || Math.abs(x.osszeg) > Math.abs(m.osszeg) ? x : m), null);
      if (elteres && legnagyobb) legnagyobb.osszeg += elteres;
    }
    this.szerk.sorok = sorok.length ? sorok : [this.uresSor()];
  }

  /*  Megnyitott bizonylat → számlasorok. A mi mentésünk szerkezetét (költség/bevétel sorok + ÁFA
   *  sorok kulcsonként) pontosan visszaadja; ha a kontír ettől eltér (kézi kontír, vegyes napló),
   *  a Kontírozás fül nyílik, és a kézi kontír marad érvényben. */
  szamlasorokbol() {
    this.kontirKezi = false;
    if (!this.szamlasoros) { this.szamlasorok = [this.ujSzamlasor()]; this.ful = 'kontir'; return; }
    const vevo = this.szerk.naplo_tipus === 'vevo';
    const vartOldal = vevo ? 'K' : 'T';
    const afaSzlak = [this.afaFizSzla, this.afaEloSzla];
    // ÁFA-sor: a beállított ÁFA-számla, vagy annak alszámlája (466x / 467x).
    const afaSorE = (sz: any) => afaSzlak.some((a) => a && String(sz).startsWith(String(a)));
    const sorok = (this.szerk.sorok || []).filter((x: any) => x.szamlaszam && Number(x.osszeg));
    if (!sorok.length || sorok.some((x: any) => (x.oldal || vartOldal) !== vartOldal && !afaSorE(x.szamlaszam) && !x.afa_kod)) {
      this.szamlasorok = [this.ujSzamlasor()]; this.kontirKezi = sorok.length > 0; this.ful = sorok.length ? 'kontir' : 'szamlasor';
      return;
    }
    const alap = sorok.filter((x: any) => !afaSorE(x.szamlaszam));
    const afaSorok = sorok.filter((x: any) => afaSorE(x.szamlaszam));
    const lista: any[] = alap.map((x: any) => {
      const k = x.afa_kulcs != null ? Number(x.afa_kulcs) : 0;
      //  A FAD-jelölt sor fordított adózású: visszanyitáskor is annak kell látszania (különben a
      //  mentés utáni ÁFA-kérdés elmaradna, és a jelölő üresen jönne vissza).
      const fordit = String(x.afa_kod || '').toUpperCase() === 'FAD';
      //  Alanyi adómentes ügyfélnél a kód nélküli, ÁFA nélküli sor AAM (nem 0%: az más bevallási tétel).
      const kod = x.afa_kod || (!this.ugyfelAfas && !fordit ? 'AAM' : null);
      return { megj: x.megnevezes || '', afa_kulcs: k, afa_kod: kod, afa_v: kod || String(k),
        afas: !fordit && !!this.ugyfelAfas && !!(k || kod), fordit, fordit_jogcim: x.fordit_jogcim || (fordit ? 'belfoldi' : null),
        bev_sor: x.bevallas_sor || '', _bevSorKezi: !!x.bevallas_sor, adokod: x.adokod || '', munkaszam: x.munkaszam || '',
        levonhato: x.levonhato_arany != null ? Math.round(Number(x.levonhato_arany) * 10000) / 100 : '', _arany: x.levonhato_arany != null ? Number(x.levonhato_arany) : 1,
        osszesito: x.osszesito || null, oldal: x.oldal || vartOldal, afa_szla: '',
        fok: x.szamlaszam, netto: Number(x.osszeg), afa: 0, brutto: 0 };
    });
    // Az ÁFA kulcsonként (és bevallási soronként) össze van vonva: szétosztjuk az azonos kulcsú sorokra.
    for (const a of afaSorok) {
      const k = Number(a.afa_kulcs) || 0;
      const kulcsos = lista.filter((x) => Number(x.afa_kulcs) === k);
      const bevSzerint = kulcsos.filter((x) => (x.bev_sor || '') === (a.bevallas_sor || ''));
      const csoport = bevSzerint.length ? bevSzerint : kulcsos;
      const alapSzla = vevo ? this.afaFizSzla : this.afaEloSzla;
      if (String(a.szamlaszam) !== String(alapSzla)) csoport.forEach((x) => (x.afa_szla = a.szamlaszam));
      if (!csoport.length) { this.kontirKezi = true; break; }
      let marad = Number(a.osszeg);
      csoport.forEach((x, i) => {
        const r = i === csoport.length - 1 ? marad : Math.round(x.netto * k / 100 * 100) / 100;
        x.afa = Math.round((x.afa + r) * 100) / 100; marad -= r;
      });
    }
    //  Részben levonható ÁFA: a tárolt költség = nettó + a le nem vonható ÁFA; a számlasorba a
    //  valódi nettót és a teljes ÁFA-t adjuk vissza.
    for (const x of lista) {
      if (x._arany < 1 && Number(x.afa_kulcs) > 0) {
        const k = Number(x.afa_kulcs) / 100;
        x.netto = Math.round(x.netto / (1 + k * (1 - x._arany)) * 100) / 100;
        x.afa = Math.round(x.netto * k * 100) / 100;
      }
      delete x._arany;
    }
    for (const x of lista) x.brutto = Math.round((x.netto + x.afa) * 100) / 100;
    // Nem áfaalany (alanyi adómentes) beszerzésénél a költségre a BRUTTÓ kerül: a beszerzés ÁFA-ja
    // NEM levonható, ezért nincs nettó/ÁFA-bontás – a teljes bruttó a költség, az ÁFA 0 (a szállító
    // 27%-át sem bontjuk vissza, különben a behúzáskor tévesen kitöltené az ÁFA-mezőt és elcsúsztatná
    // a nettót). A tárolt összeg a bruttó → nettó = bruttó, ÁFA = 0, kulcs = 0 (AAM). Igazodik a
    // szamlasorSzamol-hoz (afas===false → k=0) és az ujSzamlasor AAM-alapértékéhez.
    if (!vevo && !this.ugyfelAfas) {
      for (const x of lista) { const br = x.netto; x.brutto = br; x.netto = br; x.afa = 0; x.afa_kulcs = 0; }
    }
    this.szamlasorok = lista.length ? lista : [this.ujSzamlasor()];
    this.szamlasorokIgazit();
    this.ful = this.kontirKezi ? 'kontir' : 'szamlasor';
  }
  /** A Kontírozás fülön kézzel módosított kontír: a számlasorok ezután nem írják felül. */
  kontirKezzel() { this.kontirKezi = true; }
  kontirUjraepit() { this.kontirKezi = false; this.kontirEpit(); }

  /** Enterre a következő mezőre lép. */
  enterTovabb(e: Event) {
    const cel = e.target as HTMLElement;
    if (!cel || cel.tagName === 'TEXTAREA' || cel.tagName === 'BUTTON') return;
    const mezok = Array.from(this.urlap?.nativeElement.querySelectorAll<HTMLElement>('input:not([disabled]):not([readonly]):not([type=checkbox]), select:not([disabled])') || []);
    const i = mezok.indexOf(cel);
    if (i >= 0 && i < mezok.length - 1) { e.preventDefault(); mezok[i + 1].focus(); (mezok[i + 1] as HTMLInputElement).select?.(); }
  }
  urlapFokusz() {
    setTimeout(() => {
      this.urlap?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.urlap?.nativeElement.querySelector<HTMLInputElement>('input[type=date]')?.focus();
    }, 50);
  }
  fmt0(n: any): string {
    const v = Number(n) || 0;
    const [e, t] = Math.abs(v).toFixed(Math.abs(v - Math.round(v)) < 0.005 ? 0 : 2).split('.');
    return (v < 0 ? '−' : '') + e.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + (t ? ',' + t : '');
  }
  /** Eltérő ÁFA-esedékesség: kikapcsolva az ÁFA-teljesítés a teljesítéssel azonos. */
  elteroAfa = false;
  teljesitesValt() { if (!this.elteroAfa && this.szerk) this.szerk.afa_datum = this.szerk.teljesites; }
  // partner/megnevezés változáskor frissül a javaslat
  async javaslatFrissit() {
    const j: any = await this.post(`/kontir-javaslat/${this.aktiv.ugyfelId}`, { naplo_tipus: this.szerk.naplo_tipus, partner_nev: this.szerk.partner_nev, partner_id: this.szerk.partner_id || null, megnevezes: this.szerk.megnevezes });
    this.javaslatok = j.javaslatok || [];
    this.bevTanultAtvesz(j.bevsor_tanult);
    this.bevTanultIgazit();   // partnerváltás: a már rögzített (gépi) számlasorok is igazodnak
  }
  // egy javaslat alkalmazása az első üres főkönyvi számú SZÁMLASORRA (számlasoros naplóban)
  javaslatSzamlasorra(j: any) {
    if (!this.szamlasoros || this.ful !== 'szamlasor') return this.javaslatAlkalmaz(j);
    const x = this.szamlasorok.find((y: any) => !y.fok) || this.szamlasorok[this.szamlasorok.length - 1];
    x.fok = j.szamlaszam; if (j.afa_kulcs != null) x.afa_kulcs = Number(j.afa_kulcs);
    this.szamlasorValt();
  }
  // egy javaslat alkalmazása az első üres számlájú sorra
  javaslatAlkalmaz(j: any) {
    let sor = this.szerk.sorok.find((s: any) => !s.szamlaszam);
    if (!sor) { sor = this.uresSor(); this.szerk.sorok.push(sor); }
    sor.szamlaszam = j.szamlaszam; if (j.afa_kulcs != null) sor.afa_kulcs = j.afa_kulcs;
  }

  // ÁFA-segéd: a cég áfás státuszát figyelve generál ÁFA-sorokat (fordított adózásnál is).
  // Minden ÁFA-sor a SAJÁT T/K oldalát hozza (a fordított pár 466 T / 467 K így helyesen kerül be).
  // A FORDÍTOTT adó ÖNÁLLÓ bizonylat (a 467 nem a szállítóval áll szemben): a sorait nem ehhez a
  // bizonylathoz fűzzük, hanem mentéskor külön vegyes bizonylatot készítünk belőlük.
  forditSorok: any[] = [];
  forditAfa = 0;
  forditMeglevo = false;        // az ÁFA-bizonylat MÁR létezik (visszanyitáskor) – ne készüljön újra
  forditTorol() { this.forditSorok = []; this.forditAfa = 0; this.forditMeglevo = false; }
  // Meglévő bizonylat megnyitásakor: van-e már fordított ÁFA bizonylata („<bizonylatszám> ÁFA")?
  private async forditBetolt(bizonylatszam: string) {
    this.forditTorol();
    const biz = String(bizonylatszam || '').trim();
    if (!biz) return;
    try {
      const t: any = await this.get(`/tetel-bizonylat/${this.aktiv.ugyfelId}?biz=${encodeURIComponent(biz + ' ÁFA')}`);
      if (!t || !t.sorok?.length) return;
      this.forditSorok = t.sorok.map((s: any) => ({ szamlaszam: s.szamlaszam, tartozik: Number(s.tartozik) || 0, kovetel: Number(s.kovetel) || 0, afa_kulcs: s.afa_kulcs, megjegyzes: s.megjegyzes }));
      this.forditAfa = this.forditSorok.reduce((m: number, s: any) => Math.max(m, s.tartozik, s.kovetel), 0);
      this.forditMeglevo = true;
    } catch { /* nincs ÁFA-bizonylat – marad üres */ }
  }
  async afaSorokHozzaad() {
    if (!this.afaSeged.alap) return this.hiba('Add meg az ÁFA alapját.');
    const irany = this.szerk.naplo_tipus === 'vevo' ? 'ertekesites' : 'beszerzes';
    // A FORDÍTOTT adó önálló, FORINTOS bizonylatra megy → az alapot előbb forintosítjuk, és
    // forintban (egész összegre) számoljuk. Az egyenes ÁFA a bizonylat pénznemében marad
    // (devizánál nincs kerekítés – a forintosítás a bizonylat mentésekor történik).
    const devizasBiz = !!(this.szerk.devizas && Number(this.szerk.arfolyam) > 0);
    const alap = this.afaSeged.fordit && devizasBiz ? this.hufErtek(this.afaSeged.alap) : Number(this.afaSeged.alap);
    const deviza = this.afaSeged.fordit ? 'HUF' : (devizasBiz ? this.szerk.deviza : 'HUF');
    const r: any = await this.post(`/afa-sorok/${this.aktiv.ugyfelId}`, { alap, kulcs: this.afaSeged.kulcs, fordit: this.afaSeged.fordit, irany, deviza });
    if (!r.sorok?.length) return this.hiba(r.afas ? 'Nincs generálható ÁFA-sor.' : 'Alanyi mentes cégnél egyenes ÁFA-sor nincs (az adó a költség része).');
    if (r.kulon_bizonylat) {
      this.forditSorok = r.sorok; this.forditAfa = r.afa;
      this.ok(`Fordított ÁFA ${r.afa} – külön bizonylatként készül el mentéskor.`);
    } else {
      for (const s of r.sorok) {
        this.szerk.sorok.push({ szamlaszam: s.szamlaszam, megnevezes: s.megjegyzes || '', osszeg: (Number(s.tartozik) || 0) || (Number(s.kovetel) || 0) || null, afa_kulcs: s.afa_kulcs, oldal: (Number(s.tartozik) || 0) > 0 ? 'T' : 'K' });
      }
    }
    this.afaSeged.alap = null;
  }
  private async forditBizonylatMent() {
    if (!this.forditSorok.length || this.forditMeglevo) return;   // már létezik – ne duplikáljuk
    const d = this.szerk.afa_datum || this.szerk.teljesites || this.szerk.datum;
    await this.post(`/tetel/${this.aktiv.ugyfelId}?ev=${this.aktiv.ev}`, {
      naplo_tipus: 'vegyes', datum: d, teljesites: d, afa_datum: d,
      bizonylatszam: (this.szerk.bizonylatszam || '') + ' ÁFA',
      partner_nev: this.szerk.partner_nev, partner_id: this.szerk.partner_id,
      megnevezes: 'Fordított ÁFA – ' + (this.szerk.partner_nev || this.szerk.bizonylatszam || ''),
      munkaszam: this.szerk.munkaszam || null,
      sorok: this.forditSorok.map((s: any) => ({ szamlaszam: s.szamlaszam, tartozik: Number(s.tartozik) || 0, kovetel: Number(s.kovetel) || 0, afa_kulcs: s.afa_kulcs || null, megjegyzes: s.megjegyzes || null })),
    });
  }

  // a sorok oldalankénti összege (minden sornak SAJÁT T/K oldala van)
  private oldalSum(oldal: 'T' | 'K') { return Math.round((this.szerk?.sorok || []).reduce((s: number, x: any) => s + (((x.oldal || this.alapSorOldal()) === oldal) ? (Number(x.osszeg) || 0) : 0), 0) * 100) / 100; }
  // a FŐLÁB a kiegyenlítő: az összege a két oldal különbsége, oldala a kisebb oldalra esik
  get foOsszeg() { return Math.abs(Math.round((this.oldalSum('T') - this.oldalSum('K')) * 100) / 100); }
  get foOldal() { return this.oldalSum('T') >= this.oldalSum('K') ? 'K' : 'T'; }   // származtatott: a hiányzó oldalra
  get tSum() { return Math.round((this.oldalSum('T') + (this.foOldal === 'T' ? this.foOsszeg : 0)) * 100) / 100; }
  get kSum() { return Math.round((this.oldalSum('K') + (this.foOldal === 'K' ? this.foOsszeg : 0)) * 100) / 100; }
  get egyensulyban() {
    if (!this.szerk?.foszamla || this.foOsszeg <= 0) return false;
    return this.szerk.sorok.every((s: any) => s.szamlaszam && (Number(s.osszeg) || 0) > 0 && (s.oldal === 'T' || s.oldal === 'K')) && this.tSum === this.kSum;
  }
  // a backend teljes T/K sorai: minden sor a saját oldalán + a FŐLÁB a kiegyenlítő összeggel/oldallal.
  // Devizás tételnél az összegeket MNB-árfolyammal HUF-ra váltjuk, a főláb HUF-ban egyenlít ki (kerekítés-biztosan).
  private epitSorok() {
    const arf = this.szerk.devizas && Number(this.szerk.arfolyam) > 0 ? Number(this.szerk.arfolyam) : 1;
    //  Forintban EGÉSZ összeg – fillér nincs (user, 2026-10-07); a főláb a kerekített sorokat egyenlíti ki.
    const huf = (v: any) => Math.round((Number(v) || 0) * arf);
    const out = this.szerk.sorok.filter((s: any) => s.szamlaszam && (Number(s.osszeg) || 0) > 0).map((s: any) => {
      const oldal = s.oldal || this.alapSorOldal();
      const v = huf(s.osszeg);
      return { szamlaszam: String(s.szamlaszam).trim(), tartozik: oldal === 'T' ? v : 0, kovetel: oldal === 'K' ? v : 0, afa_kulcs: s.afa_kulcs || null, megjegyzes: s.megnevezes || null,
        afa_kod: s.afa_kod || null, bevallas_sor: s.bevallas_sor || null, osszesito: s.osszesito || null,
        //  Eddig kimaradt: az adókód és a fordított adózás jogcíme a kontírsoron volt, de a
        //  mentésbe nem került át – így a bizonylat visszanyitásakor és az analitikában elveszett.
        adokod: s.adokod || null, fordit_jogcim: s.fordit_jogcim || null, munkaszam: s.munkaszam || null,
        levonhato_arany: s.levonhato_arany ?? null };
    });
    //  Végszámla előlegből: a beszámítás (2. tétel) a bizonylat saját sora – kiegyensúlyozott pár, a főlábat nem változtatja.
    for (const l of this.lepesek.filter((x) => x.naplo_tipus === 'fo')) {
      const megj = String(l.megnevezes || '').startsWith(BESZAMITAS_JEL) ? l.megnevezes : `${BESZAMITAS_JEL}${l.megnevezes ? ' – ' + l.megnevezes : ''}`;
      for (const x of l.sorok || []) {
        const v = Math.round(Number(x.osszeg) || 0);
        if (!x.szamlaszam || !v) continue;
        out.push({ szamlaszam: String(x.szamlaszam).trim(), tartozik: x.oldal === 'T' ? v : 0, kovetel: x.oldal === 'K' ? v : 0, afa_kulcs: null, megjegyzes: megj,
          afa_kod: null, bevallas_sor: null, osszesito: null, adokod: null, fordit_jogcim: null, munkaszam: null, levonhato_arany: null });
      }
    }
    const tS = Math.round(out.reduce((a, b) => a + b.tartozik, 0) * 100) / 100;
    const kS = Math.round(out.reduce((a, b) => a + b.kovetel, 0) * 100) / 100;
    const foHuf = Math.abs(Math.round((tS - kS) * 100) / 100);
    const foOldal = tS >= kS ? 'K' : 'T';
    out.push({ szamlaszam: String(this.szerk.foszamla).trim(), tartozik: foOldal === 'T' ? foHuf : 0, kovetel: foOldal === 'K' ? foHuf : 0, afa_kulcs: null, megjegyzes: this.szerk.megnevezes || null });
    return out;
  }
  // HUF-előnézet egy deviza-sorhoz / a fő lábhoz
  hufErtek(devOsszeg: any) { const a = this.szerk?.devizas && Number(this.szerk?.arfolyam) > 0 ? Number(this.szerk.arfolyam) : 1; return Math.round((Number(devOsszeg) || 0) * a); }
  // MNB középárfolyam lekérése a kiválasztott pénznemre + bizonylat dátumára (a naplo-bank modul végpontján át)
  async arfolyamFrissit() {
    if (!this.szerk?.devizas || !this.szerk?.deviza) return;
    const datum = (this.szerk.datum || new Date().toISOString().slice(0, 10)).slice(0, 10);
    try {
      const r: any = await firstValueFrom(this.http.get(`/api/naplo-bank/mnb?deviza=${encodeURIComponent(this.szerk.deviza)}&datum=${datum}`));
      if (r?.arfolyam) this.szerk.arfolyam = Math.round(Number(r.arfolyam) * 10000) / 10000;
    } catch { this.hiba('MNB árfolyam nem elérhető – add meg kézzel.'); }
  }
  // Deviza-kapcsoló: a fix főláb átvált a deviza-partnerszámlára (317/4542) és vissza – de csak
  // akkor, ha a mező még a másik alapértelmezésen áll (kézzel átírt számot nem bántunk).
  devizaValt() {
    if (this.szerk.devizas && !this.szerk.deviza) this.szerk.deviza = 'EUR';
    const t = this.szerk.naplo_tipus;
    const elozo = this.foszamlaAlap(t, !this.szerk.devizas);
    const uj = this.foszamlaAlap(t, !!this.szerk.devizas);
    if (uj && (!this.szerk.foszamla || this.szerk.foszamla === elozo)) this.szerk.foszamla = uj;
    if (this.szerk.devizas) this.arfolyamFrissit();
  }

  // --- főkönyvi szám választó a törzsből (számlatükör) ---
  szlaValasztoCel: any = null;   // { sor } vagy { fo:true }
  szlaKereso = '';
  nyitSzlaValaszto(cel: any) { this.szlaValasztoCel = cel; this.szlaKereso = ''; this.szlaValaszto.present(); }
  get szlaTalalat() {
    const q = this.szlaKereso.trim().toLowerCase();
    const lista = (this.tukor || []).filter((x: any) => !x.gyujto);   // gyűjtőszámlára nem könyvelünk
    if (!q) return lista.slice(0, 60);
    return lista.filter((x: any) => String(x.szamlaszam).includes(q) || String(x.nev || '').toLowerCase().includes(q)).slice(0, 60);
  }
  valasztSzla(x: any) {
    if (this.szlaValasztoCel?.fo) this.szerk.foszamla = x.szamlaszam;
    else if (this.szlaValasztoCel?.szamlasor) { this.szlaValasztoCel.szamlasor.fok = x.szamlaszam; this.adokodAuto(this.szlaValasztoCel.szamlasor); this.szamlasorValt(); }
    else if (this.szlaValasztoCel?.sor) this.szlaValasztoCel.sor.szamlaszam = x.szamlaszam;
    this.szlaValaszto.dismiss();
  }

  /*  A Naplókból nyitva: ide térünk vissza („Vissza a naplóhoz", és mentés után magától). */
  visszaUt: string | null = null;
  private parameterLevetel = false;
  visszaNaplo(kijelol?: string | null) {
    const ut = this.visszaUt;
    if (!ut) return;
    this.visszaUt = null;
    this.zarEngedd('zarTetel');
    // A kiinduló sor (ha volt) már benne van az útban; új tételnél a mentett bizonylat lesz kijelölve.
    this.router.navigateByUrl(ut + (kijelol && !/[?&]kijelol=/.test(ut) ? `&kijelol=${encodeURIComponent(kijelol)}` : ''));
  }

  /* ══════════ A FORDÍTOTT ÁFA KÖNYVELÉSE (a mentés utolsó lépése) ══════════
   *
   *  A számlán nincs ÁFA, az adót önadózzuk – ez viszont ÖNÁLLÓ (vegyes) bizonylat, nem a
   *  szállítói tartozás része. Ezért a bizonylat mentése UTÁN kérdezünk rá, és csak akkor
   *  készítjük el, ha kérik. Az ablak a fizetendő és a levonható oldalt is mutatja, mert a
   *  bevallási sor és az adókód oldalanként más lehet. */
  forditAblak: any = null;
  forditElonezet: any[] = [];

  /* ══════════ TÁRGYI ESZKÖZ FELVÉTELE A SZÁLLÍTÓI SZÁMLÁBÓL ══════════
   *
   *  Ha a szállítói számla a 161-es (befejezetlen beruházás) vagy közvetlenül egy 11–14-es eszköz-
   *  számlára megy, a mentés után felajánljuk, hogy a tétel a Tárgyi eszköz nyilvántartásba is
   *  bekerüljön – a bizonylatra hivatkozva, így ugyanabból a bizonylatból nem kérdezünk kétszer.
   *  A bekerülési érték a könyvelt összeg: nem áfaalanynál abban már benne van a le nem vonható ÁFA
   *  (Szt. 47. § (2)). A 161-es tétel „beruházás" marad écs nélkül, amíg nem aktiválják (T 13x / K 161). */
  eszkozFelvetel: any = null;
  private eszkozFelvetelKesz: (() => void) | null = null;
  private eszkozJeloltSorok(): any[] {
    if (this.szerk?.naplo_tipus !== 'szallito') return [];
    return this.epitSorok().filter((s: any) => /^(1[1-4]|16)/.test(String(s.szamlaszam)) && Number(s.tartozik) > 0);
  }
  private static eszkozCsoport(szla: string): string {
    if (/^11/.test(szla)) return 'immaterialis';
    if (/^121/.test(szla)) return 'epulet';
    if (/^12/.test(szla)) return 'epitmeny';
    if (/^133/.test(szla)) return 'szamitastechnika';
    if (/^14/.test(szla)) return 'jarmu';
    return 'gep';
  }
  private async eszkozKerdes(tetelId: string | null, sorok: any[]) {
    if (!tetelId || !sorok.length) return;
    let csoportok: any[] = [], hatar = 200000;
    try {
      const mar: any = await firstValueFrom(this.http.get(`/api/eszkoz/tetel/${tetelId}`));
      if ((mar?.eszkozok || []).length >= sorok.length) return;            // ebből a bizonylatból már felvették
      csoportok = ((await firstValueFrom(this.http.get<any>('/api/eszkoz/csoportok')))?.csoportok) || [];
      hatar = Number((await firstValueFrom(this.http.get<any>(`/api/eszkoz/beallitas/${this.aktiv.ugyfelId}`)))?.kis_erteku_hatar) || 200000;
    } catch { return; }                                                     // nincs Tárgyi eszköz jog: nem kérdezünk
    const d = this.szerk?.teljesites || this.szerk?.datum || new Date().toISOString().slice(0, 10);
    const partner = this.szerk?.partner_nev || '';
    this.eszkozFelvetel = {
      tetel_id: tetelId, csoportok,
      //  A szállító és a számla – az eszköznél is látszik, és onnan a bizonylat visszanyitható.
      partner_id: this.szerk?.partner_id || null, partner_nev: partner || null,
      szamlaszam: this.szerk?.bizonylatszam || this.szerk?.osa_szamlaszam || null,
      sorok: sorok.map((s: any) => {
        const szla = String(s.szamlaszam);
        const beruhazas = /^16/.test(szla);
        const csoport = KettosComponent.eszkozCsoport(szla);
        const cs = csoportok.find((c: any) => c.kulcs === csoport) || {};
        const ertek = Math.round(Number(s.tartozik) * 100) / 100;
        return {
          jelol: true, szamla: szla, beruhazas, csoport,
          megnevezes: s.megjegyzes || this.szerk?.megnevezes || partner || '',
          leltari_szam: '', brutto_ertek: ertek, beszerzes_datum: d,
          aktivalas_datum: beruhazas ? '' : d,
          fokonyvi_szamla: beruhazas ? (cs.szamlak?.brutto || '131') : szla,
          ecs_szamla: beruhazas ? (cs.szamlak?.ecs || '139') : `${szla.slice(0, 2)}9`,
          ecs_mod: ertek < hatar ? 'azonnali' : 'linearis', ecs_kulcs: cs.tao ?? 14.5,
          munkaszam: s.munkaszam || '',
        };
      }),
    };
    await new Promise<void>((kesz) => { this.eszkozFelvetelKesz = kesz; });
  }
  eszkozFelvetelCsoport(x: any) {
    const cs = (this.eszkozFelvetel?.csoportok || []).find((c: any) => c.kulcs === x.csoport);
    if (!cs) return;
    x.ecs_kulcs = cs.tao;
    if (x.beruhazas) { x.fokonyvi_szamla = cs.szamlak.brutto; x.ecs_szamla = cs.szamlak.ecs; }
  }
  eszkozFelvetelZar() {
    this.eszkozFelvetel = null;
    const k = this.eszkozFelvetelKesz; this.eszkozFelvetelKesz = null; k?.();
  }
  async eszkozFelvetelMent() {
    const f = this.eszkozFelvetel;
    const jelolt = (f?.sorok || []).filter((x: any) => x.jelol);
    if (jelolt.some((x: any) => !String(x.megnevezes || '').trim())) return this.hiba('Minden felvett eszköznek adj megnevezést.');
    let db = 0, aktivalt = 0;
    try {
      for (const x of jelolt) {
        const r: any = await firstValueFrom(this.http.post(`/api/eszkoz/eszkoz/${this.aktiv.ugyfelId}`, {
          megnevezes: x.megnevezes, leltari_szam: x.leltari_szam, csoport: x.csoport,
          fokonyvi_szamla: x.fokonyvi_szamla, ecs_szamla: x.ecs_szamla,
          beszerzes_datum: x.beszerzes_datum, aktivalas_datum: x.beruhazas ? null : x.aktivalas_datum,
          brutto_ertek: x.brutto_ertek, ecs_mod: x.ecs_mod, ecs_kulcs: x.ecs_kulcs,
          munkaszam: x.munkaszam, tetel_id: f.tetel_id, beruhazas_szamla: x.beruhazas ? x.szamla : null,
          partner_id: f.partner_id, partner_nev: f.partner_nev, szamlaszam: f.szamlaszam,
        }));
        db++;
        //  A beruházás azonnali üzembe helyezése: vegyes bizonylat T 13x / K 161.
        if (x.beruhazas && x.aktivalas_datum && r?.id) {
          await firstValueFrom(this.http.post(`/api/eszkoz/eszkoz/${r.id}/aktivalas`, { datum: x.aktivalas_datum, konyvel: true }));
          aktivalt++;
        }
      }
      this.ok(`${db} tárgyi eszköz felvéve${aktivalt ? `, ${aktivalt} aktiválva (vegyes napló, T 13x / K 161)` : ''}.`);
      this.eszkozFelvetelZar();
    } catch (e: any) {
      this.hiba(e?.status === 403 ? 'Nincs jogosultságod a Tárgyi eszköz modulhoz.' : (e?.error?.error || 'Nem sikerült felvenni az eszközt.') + (db ? ` (${db} már felvéve)` : ''));
    }
  }

  private async forditKerdes(tetelId: string | null) {
    if (!this.forditAlapOsszeg) return;
    const a = await this.alert.create({
      header: 'Automatikus könyvelés',
      message: 'Szeretné lekönyvelni a fordított adózáshoz kapcsolódó ÁFA-t a vegyes naplóba?',
      buttons: [{ text: 'Nem', role: 'cancel' }, { text: 'Igen', role: 'ok' }],
    });
    await a.present();
    if ((await a.onDidDismiss()).role !== 'ok') return;
    await this.forditAblakNyit(tetelId);
  }

  async forditAblakNyit(tetelId: string | null) {
    await this.adokodokBetolt();
    const d = this.szerk?.afa_datum || this.szerk?.teljesites || this.szerk?.datum || new Date().toISOString().slice(0, 10);
    const sor = this.szamlasorok.find((x: any) => x.fordit) || {};
    this.forditAblak = {
      tetel_id: tetelId, alap: this.forditAlapOsszeg, kulcs: 27, csak_afa: false,
      /*  A 65-ös bevallás sorai (naplo_bevallas_sor törzs): a fordított adózás szerint FIZETENDŐ
       *  adó a 29. sor, a levonható oldal kulcsonként a 66. (27%), 65. (18%), 64. (5%) sor.
       *  Nem áfaalanynál nincs levonás: ott a 63. sor (adómentes belföldi beszerzés adóalapja). */
      jogcim: sor.fordit_jogcim || 'belfoldi',
      fizetendo: { datum: d, bizonylatszam: this.szerk?.bizonylatszam || '', munkaszam: this.szerk?.munkaszam || '', partner_nev: this.szerk?.partner_nev || '',
        megjegyzes: 'Fiz.ÁFA', bev_sor: this.forditJogcim(sor.fordit_jogcim).fiz[27], adokod: sor.adokod || '', afa_szla: this.afaFizSzla },
      levonhato: { datum: d, bizonylatszam: this.szerk?.bizonylatszam || '', munkaszam: this.szerk?.munkaszam || '', partner_nev: this.szerk?.partner_nev || '',
        //  Nem áfaalanynál nincs levonható oldal: az adó ráfordítás (a kiszolgáló 8671-re könyveli).
        megjegyzes: 'Lev.ÁFA', bev_sor: this.ugyfelAfas ? this.forditJogcim(sor.fordit_jogcim).lev[27] : '', adokod: this.ugyfelAfas ? (sor.adokod || '') : '', afa_szla: this.afaEloSzla },
    };
    /*  A számlasoron VÁLASZTOTT adókód viszi a sorokat – oldalanként, amelyik oldala van: a páros kód
     *  (MP14 MD69) mindkettőt, az egyoldalú (pl. MD69 DD78 – apport levonása) csak a levonhatót, a
     *  fizetendő oldal ilyenkor a jogcím szerinti marad. A kód csak arra az oldalra kerül, amelyiket leírja. */
    const kodA = this.adokodKeres(sor.adokod);
    if (kodA) {
      const f = this.forditAblak;
      if (kodA.fizetendo_sor) f.fizetendo.bev_sor = kodA.fizetendo_sor; else f.fizetendo.adokod = '';
      if (kodA.levonhato_sor && this.ugyfelAfas) f.levonhato.bev_sor = kodA.levonhato_sor; else f.levonhato.adokod = '';
    }
    this.forditAdokodIgazit();
    await this.forditElonezetFrissit();
  }
  /*  A fordított ÁFA ablak adókódja a két bevallási sorból: ha van rájuk páros kód (29+66 → 6629),
   *  az kerül mindkét oldalra, különben a sor saját kódja. A kézzel választotthoz nem nyúlunk. */
  private forditAdokodIgazit() {
    const x = this.forditAblak; if (!x) return;
    const fiz = String(x.fizetendo.bev_sor || ''), lev = String(x.levonhato.bev_sor || '');
    //  A két sorra mutató LEGEGYSZERŰBB kód (MP29 MD66 – nem a részletezős MP29 DP54 MD66 változat).
    const par = this.adokodok.filter((a: any) => String(a.fizetendo_sor || '') === fiz && String(a.levonhato_sor || '') === lev)
      .sort((a: any, b: any) => a._elemek - b._elemek)[0];
    for (const o of [x.fizetendo, x.levonhato]) {
      if (o.adokod && o.adokod !== o._adokodAuto) continue;
      const sajat = this.adokodSorbol(o.bev_sor, o === x.fizetendo ? 'fiz' : 'lev');
      o.adokod = par ? par.kod : (sajat ? sajat.kod : '');
      o._adokodAuto = o.adokod;
    }
  }

  /**  A levonható oldal bevallási sora a kulcshoz igazodik (66/65/64), ha a könyvelő nem írta át. */
  forditKulcsValt() {
    const x = this.forditAblak;
    if (!x) return;
    //  A jogcím + a kulcs adja a bevallási sorokat (65-ös nyomtatvány); a kézzel átírt sorhoz nem nyúlunk.
    const j = this.forditJogcim(x.jogcim);
    const k = Number(x.kulcs);
    if (!x.fizetendo.bev_sor || Object.values(j.fiz).includes(String(x.fizetendo.bev_sor))) x.fizetendo.bev_sor = j.fiz[k] || j.fiz[27];
    if (this.ugyfelAfas && (!x.levonhato.bev_sor || Object.values(j.lev).includes(String(x.levonhato.bev_sor)))) x.levonhato.bev_sor = j.lev[k] || j.lev[27];
    this.forditAdokodIgazit();
    this.forditElonezetFrissit();
  }

  async forditElonezetFrissit() {
    const x = this.forditAblak;
    if (!x) return;
    try {
      const r: any = await this.post(`/forditott-afa/${this.aktiv.ugyfelId}`, {
        alap: Number(x.alap) || 0, kulcs: Number(x.kulcs) || 0, csak_afa: !!x.csak_afa, jogcim: x.jogcim,
        fizetendo: x.fizetendo, levonhato: x.levonhato,
      });
      this.forditElonezet = r.sorok || [];
      x.afa = r.afa; x.brutto = r.brutto; x.egyensulyban = r.egyensulyban;
    } catch { this.forditElonezet = []; }
  }

  /** A fordított ÁFA önálló vegyes bizonylata (a számla bizonylatszáma + „ÁFA"). */
  async forditAblakMent() {
    const x = this.forditAblak;
    if (!x || !this.forditElonezet.length) return;
    try {
      await this.post(`/tetel/${this.aktiv.ugyfelId}?ev=${this.aktiv.ev}`, {
        naplo_tipus: 'vegyes', datum: x.fizetendo.datum, teljesites: x.fizetendo.datum, afa_datum: x.fizetendo.datum,
        bizonylatszam: (x.fizetendo.bizonylatszam || this.szerk?.bizonylatszam || '') + ' ÁFA',
        partner_nev: x.fizetendo.partner_nev || this.szerk?.partner_nev, partner_id: this.szerk?.partner_id,
        megnevezes: 'Fordított ÁFA – ' + (x.fizetendo.partner_nev || this.szerk?.bizonylatszam || ''),
        munkaszam: x.fizetendo.munkaszam || x.levonhato.munkaszam || this.szerk?.munkaszam || null,
        sorok: this.forditElonezet.map((s: any) => ({
          szamlaszam: s.szamlaszam, tartozik: Number(s.tartozik) || 0, kovetel: Number(s.kovetel) || 0,
          afa_kulcs: s.afa_kulcs || null, megjegyzes: s.megjegyzes || null,
          afa_kod: s.afa_kod || null, bevallas_sor: s.bevallas_sor || null, adokod: s.adokod || null,
        })),
      });
      this.forditAblak = null; this.forditElonezet = [];
      await this.tetelekBetolt();
      this.ok('A fordított ÁFA a vegyes naplóba könyvelve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült könyvelni a fordított ÁFA-t.'); }
  }

  async mentTetel() {
    if (this.zarTilt(this.zarTetel)) return;
    if (!this.szerk?.foszamla) return this.hiba('Add meg a fő számlát (a napló fix lábát).');
    await this.adokodokBetolt();
    const kodHiba = this.adokodEllenoriz();
    if (kodHiba) return this.hiba(kodHiba);
    if (this.szamlasoros && !this.kontirKezi) this.kontirEpit();
    if (!this.egyensulyban) return this.hiba(`A tétel nincs egyensúlyban (T ${this.tSum} ≠ K ${this.kSum}).`);
    //  Új bizonylat már könyvelt számlaszámmal: a mező alatt látta, mentés előtt még egyszer rákérdezünk.
    if (!this.szerk?.id && this.bizDupla.length) {
      const hol = this.bizDupla.map((t) => `${this.naploNevBiz(t.naplo_tipus)} napló ${t.sorszam}.`).join(', ');
      if (!(await this.megerosit('Már könyvelt számlaszám', `A(z) ${this.szerk.bizonylatszam} számlaszámmal már van könyvelés (${hol}). Biztosan még egyszer könyveled?`, 'Könyvelem'))) return;
    }
    const voltOsa = !!this.szerk?.osa_szamlaszam;
    const forditVolt = this.forditSorok.length > 0;
    const forditTetelesVolt = this.forditAlapOsszeg > 0;
    const eszkozSorok = this.eszkozJeloltSorok();
    try {
      const stornoUtana = this.stornoPar && this.stornoParJelol && this.szerk?.osa_szamlaszam === this.stornoPar.eredeti_szamlaszam ? this.stornoPar : null;
      const hibasLepes = this.lepesek.find((l) => !this.lepesEgyensuly(l));
      if (hibasLepes) return this.hiba(`A kapcsolódó lépés (${hibasLepes.megnevezes}) nincs egyensúlyban.`);
      const mentett: any = await this.post(`/tetel/${this.aktiv.ugyfelId}?ev=${this.aktiv.ev}`, { ...this.szerk, sorok: this.epitSorok(),
        kapcsolodo: this.kapcsolodoKuldes(), kapcsolat_szerep: this.kapcsolatSzerep, eloleg_beszamitas: this.foBeszamitas() || null });
      this.stornoPar = null;
      if (stornoUtana) { await this.osaKonyveltBetolt(); await this.stornoKuld(stornoUtana); }
      const modosito = this.modositoPar && this.szerk?.osa_szamlaszam === this.modositoPar.szamlaszam ? this.modositoPar : null;
      this.modositoPar = null;
      if (modosito) {
        try {
          const r: any = await this.post(`/osa-modosito/${this.aktiv.ugyfelId}`, { modosito, tetel_id: mentett?.id || this.szerk?.id || null });
          this.ok(r?.fuggo ? `A módosító könyvelve. ${r.uzenet}`
            : `A módosító az eredetihez (${modosito.eredeti_szamlaszam}) kötve${r?.kiegy_igazitva ? ` – a nyitott tétel új összege ${Math.round(r.uj_brutto).toLocaleString('hu-HU')} Ft` : ''}.`);
        } catch (e: any) { this.hiba(e?.error?.error || 'A módosítót nem sikerült az eredetihez kötni.'); }
      }
      //  KÉZI módosító/storno összekötés: ha megadták az eredeti bizonylatszámot, a mentett bizonylatot
      //  az eredetihez kötjük (ugyanaz a mechanizmus, mint a behúzásból – naplo_szamla_modositas).
      const keziEredeti = String(this.szerk?.eredeti_bizonylatszam || '').trim();
      if (keziEredeti && this.szerk?.bizonylatszam && keziEredeti !== this.szerk.bizonylatszam) {
        try {
          await this.post(`/osa-modosito/${this.aktiv.ugyfelId}`, { modosito: { szamlaszam: this.szerk.bizonylatszam, eredeti_szamlaszam: keziEredeti, irany: this.szerk.naplo_tipus === 'vevo' ? 'outbound' : 'inbound' }, tetel_id: mentett?.id || this.szerk?.id || null });
          this.ok(`Összekötve az eredetivel (${keziEredeti}).`);
        } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült az eredetihez kötni.'); }
      }
      await this.forditBizonylatMent();   // a fordított ÁFA ÖNÁLLÓ bizonylata (ha kértük)
      this.forditTorol();
      //  Fordított adózású számlasor esetén a mentés UTOLSÓ lépése: rákérdezünk az ÁFA-ra.
      if (forditTetelesVolt) await this.forditKerdes(mentett?.id || this.szerk?.id || null);
      //  Beruházás (161) / tárgyi eszköz (11–14) számlára könyvelt szállítói számla: felajánljuk a felvételt.
      if (eszkozSorok.length) await this.eszkozKerdes(mentett?.id || this.szerk?.id || null, eszkozSorok);
      if (this.visszaUt) {
        this.ok('Bizonylat könyvelve.' + (forditVolt ? ' A fordított ÁFA külön bizonylatra került.' : ''));
        this.visszaNaplo(mentett?.id || this.szerk?.id);
        return;
      }
      //  Előleg: a banki bizonylat sorszáma az üzenetben, aztán vissza az előző naplóra.
      let elolegUzenet = '';
      if (this.kapcsolatSzerep === 'eloleg' && mentett?.id) {
        try { const t: any = await this.get(`/tetel/${mentett.id}`); elolegUzenet = ` Előleg: ${this.naploNevBiz(t.naplo_tipus)} napló ${this.naplosorszam(t)}${(t.kapcsolodo || []).length ? ', az ÁFA-lépés a vegyes naplóban' : ''}.`; } catch { /* csak az üzenet */ }
      }
      const vissza = this.elolegNaploElotte;
      if (vissza && this.aktivNaplo !== vissza) this.aktivNaplo = vissza;
      await this.tetelekBetolt(); await this.ujTetel(); this.urlapFokusz();
      if (voltOsa) await this.osaKonyveltBetolt();   // az OSA-listán frissüljön a „könyvelt" jelzés
      this.ok('Bizonylat könyvelve.' + elolegUzenet + (forditVolt ? ' A fordított ÁFA külön bizonylatra került.' : ''));
    } catch (e: any) { this.hiba(e?.error?.error || 'Hiba a könyvelésnél.'); }
  }
  async torolTetel(t: any) {
    if (t.id === this.szerk?.id && this.zarTilt(this.zarTetel)) return;
    const a = await this.alert.create({ header: 'Törlés', message: 'Biztosan törli a bizonylatot?', buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'destructive', handler: async () => {
      try { await this.del(`/tetel/${t.id}`); }
      catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült törölni.'); return; }
      if (t.id === this.szerk?.id) await this.ujTetel();   // a törölt bizonylat ne maradjon nyitva (a zára is elenged)
      await this.tetelekBetolt(); this.ok('Törölve.'); } }] });
    a.present();
  }

  szamlaNev(szs: string) { const s = this.tukor.find((x) => x.szamlaszam === szs); return s ? s.nev : ''; }

  // --- számlatükör ---
  ujSzla() { this.zarEngedd('zarSzla'); this.szlaSzerk = { ugyfel_id: this.aktiv.ugyfelId, szamlaszam: '', nev: '', tipus: 'eszkoz', fokonyvi: 1, gyujto: false, penzszamla: false, aktiv: true }; this.szlaModal.present(); }
  szerkSzla(s: any) {
    this.szlaSzerk = { ...s, gyujto: !!s.gyujto, penzszamla: !!s.penzszamla, aktiv: s.aktiv !== 0 }; this.szlaModal.present();
    this.zarKer('zarSzla', 'kettos_szamla', s.id, () => this.szlaUjratolt(s.id));
  }
  /** A zár felszabadulásakor: a számla friss adata a tükörből, ha az ablak még ezt mutatja. */
  private async szlaUjratolt(id: string) {
    this.tukor = await this.get(`/szamlatukor/${this.aktiv.ugyfelId}`);
    const s = this.tukor.find((x: any) => x.id === id);
    if (s && this.szlaSzerk?.id === id) this.szlaSzerk = { ...s, gyujto: !!s.gyujto, penzszamla: !!s.penzszamla, aktiv: s.aktiv !== 0 };
  }
  async mentSzla() {
    if (this.zarTilt(this.zarSzla)) return;
    if (!this.szlaSzerk?.szamlaszam || !this.szlaSzerk?.nev) return this.hiba('Számlaszám és név kötelező.');
    this.szlaSzerk.ugyfel_id = this.aktiv.ugyfelId;
    try {
      if (this.szlaSzerk.id) await this.put(`/szamla/${this.szlaSzerk.id}`, this.szlaSzerk);
      else await this.post('/szamla', this.szlaSzerk);
      await this.szlaModal.dismiss(); this.tukor = await this.get(`/szamlatukor/${this.aktiv.ugyfelId}`); this.ok('Mentve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Hiba.'); }
  }
  async torolSzla(s: any) {
    try { await this.del(`/szamla/${s.id}`); } catch (e: any) { return this.hiba(e?.error?.error || 'Nem sikerült törölni.'); }
    this.tukor = await this.get(`/szamlatukor/${this.aktiv.ugyfelId}`); this.ok('Törölve.');
  }
  // Standard RLB-tükör betöltése / hiányzó összesítők és számlák pótlása (meglévőt nem ír felül).
  async seedTukor() {
    if (!(await this.megerosit('Standard tükör', 'Betöltöd/kiegészíted a standard RLB-számlatükröt (a meglévő számláidat nem írja felül)?', 'Betöltés'))) return;
    await this.post(`/szamlatukor/seed/${this.aktiv.ugyfelId}`, {});
    this.tukor = await this.get(`/szamlatukor/${this.aktiv.ugyfelId}`); this.ok('Számlatükör frissítve.');
  }

  // --- beállítás ---
  async mentBeallitas() {
    try { await this.put(`/beallitas/${this.aktiv.ugyfelId}`, this.beallitas); this.ok('Beállítások mentve.'); }
    catch { this.hiba('Hiba.'); }
  }

  // --- partnerek (kettősben is, a naplo partner-törzset használva) ---
  ujPartner() { this.zarEngedd('zarPartner'); this.partnerSzerk = { ugyfel_id: this.aktiv.ugyfelId, nev: '', kata: false, penzforgalmi_afa: false, osszesito_nyilatkozat: false }; this.partnerModal.present(); }
  szerkPartner(p: any) {
    this.partnerSzerk = { ...p, kata: !!p.kata, penzforgalmi_afa: !!p.penzforgalmi_afa, osszesito_nyilatkozat: !!p.osszesito_nyilatkozat, ugyfel_id: this.aktiv.ugyfelId }; this.partnerModal.present();
    this.zarKer('zarPartner', 'naplo_partner', p.id, () => this.partnerUjratolt(p.id));
  }
  /** A zár felszabadulásakor: a partner friss adata a törzsből, ha az ablak még ezt mutatja. */
  private async partnerUjratolt(id: string) {
    this.partnerek = await this.naploGet(`/partnerek/${this.aktiv.ugyfelId}`);
    const p = this.partnerek.find((x: any) => x.id === id);
    if (p && this.partnerSzerk?.id === id) this.partnerSzerk = { ...p, kata: !!p.kata, penzforgalmi_afa: !!p.penzforgalmi_afa, osszesito_nyilatkozat: !!p.osszesito_nyilatkozat, ugyfel_id: this.aktiv.ugyfelId };
  }
  async mentPartner() {
    if (this.zarTilt(this.zarPartner)) return;
    if (!this.partnerSzerk?.nev?.trim()) return this.hiba('A név kötelező.');
    try {
      if (this.partnerSzerk.id) await this.naplo.put('/partner/' + this.partnerSzerk.id, this.partnerSzerk);
      else await this.naplo.post('/partner', this.partnerSzerk);
      await this.partnerModal.dismiss();
      this.partnerek = await this.naploGet(`/partnerek/${this.aktiv.ugyfelId}`);
      this.ok('Mentve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }
  async torolPartner(p: any) {
    try { await this.naplo.del('/partner/' + p.id); this.partnerek = await this.naploGet(`/partnerek/${this.aktiv.ugyfelId}`); this.ok('Törölve.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült törölni.'); }
  }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 1600, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 2800, color: 'danger' })).present(); }
}
